const userState = [
    {value: 'verified', label: '인증'},
    {value: 'not_verified', label: '미인증'},
]
const role = [
    {value: 'licensor', label: 'Licensor'},
    {value: 'contractor', label: 'Contractor'},
    {value: 'user', label: 'User'},
    {value: 'admin', label: 'Admin'},
]
const lang = [
    {value: 'en', label: '영어'},
    {value: 'ko', label: '한국어'},
]

const entity = [
    {value: 'corporation', label: '사업자'},
    {value: 'individual', label: '개인'}
]
const currency = [
    {value: 'krw', label: 'KRW'},
    {value: 'usd', label: 'USD'},
    {value: 'eur', label: 'EUR'},
]
const memberKeyword = [
    {value: 'email', label:'Email ID'},
    {value: '_name', label:'권리자명'},
    {value: 'company', label: '회사명'},
    {value: 'phone', label: '연락처'},
    {value: '_bankaccount_name', label: '예금주'},
    {value: '_lid', label: 'LID'}
    
]
const artistKeyword = [
    {value: 'email', label:'Email ID'},
    {value: '_name', label:'권리자명'},
    {value: 'company', label: '회사명'},
    {value: 'display_name', label: '아티스트명'},
    {value: 'display_name_english', label: '아티스트명(번역)'}
]
const payment = [
    {value: 'kr_banktransfer', label: "국내 계좌이체"},
    {value: 'intl_banktransfer', label: "WireTransfer"},
    {value: 'paypal', label: "PayPal"},
    // {value: 'payoneer', label: "Payoneer"}
    
]
const showNumber = [
    10,
    20,
    50,
    100
]

const reference = [
    {value: 'search', label: '검색'},
    {value: 'referral', label: '지인소개'},
    {value: 'advertisement', label: '광고'},
    {value: 'sns', label: 'SNS'},
    // {value: 'admin', label: '관리자생성'},
    {value: 'other', label: '기타'},
]
// 국가
const country = [
    {name:"대한민국 - KR", name_en: "SOUTH KOREA - KR", code: "KR"},
    {name:"중국 - CN", name_en: "CHINA - CN", code: "CN"},
    {name:"일본 - JP", name_en: "JAPAN - JP", code: "JP"},
    {name:"미국 - US", name_en: "UNITED STATES - US", code: "US"},
    {name:"영국 - GB", name_en: "UNITED KINGDOM - GB", code: "GB"},
    {name:"캐나다 - CA", name_en: "CANADA - CA", code: "CA"},
    {name:"네덜란드 - NL", name_en: "NETHERLANDS - NL", code: "NL"},
    {name:"호주 - AU", name_en: "AUSTRALIA - AU", code: "AU"},
    {name:"독일 - DE", name_en: "GERMANY - DE", code: "DE"},
    {name:"이탈리아 - IT", name_en: "ITALY - IT", code: "IT"},
    {name:"폴란드 - PL", name_en: "POLAND - PL", code: "PL"},
    {name:"루마니아 - RO", name_en: "ROMANIA - RO", code: "RO"},
    {name:"국적불명 - ZZ", name_en: "UNKNOWN - ZZ", code: "ZZ"},
    {name:"안도라 - AD", name_en: "ANDORRA - AD", code: "AD"},
    {name:"아랍에미리트 - AE", name_en: "UNITED ARAB EMIRATES - AE", code: "AE"},
    {name:"아프가니스탄 - AF", name_en: "AFGHANISTAN - AF", code: "AF"},
    {name:"안티구아 바부다 - AG", name_en: "ANTIGUA AND BARBUDA - AG", code: "AG"},
    {name:"앙길라 - AI", name_en: "ANGUILLA - AI", code: "AI"},
    {name:"알바니아 - AL", name_en: "ALBANIA - AL", code: "AL"},
    {name:"아르메니아 - AM", name_en: "ARMENIA - AM", code: "AM"},
    {name:"앙골라 - AO", name_en: "ANGOLA - AO", code: "AO"},
    {name:"안타티카 - AQ", name_en: "ANTARCTICA - AQ", code: "AQ"},
    {name:"아르헨티나 - AR", name_en: "ARGENTINA - AR", code: "AR"},
    {name:"오스트리아 - AT", name_en: "AUSTRIA - AT", code: "AT"},
    {name:"아루바 - AW", name_en: "ARUBA - AW", code: "AW"},
    {name:"알랜드 군도 - AX", name_en: "ALAND ISLANDS - AX", code: "AX"},
    {name:"아제르바이잔 - AZ", name_en: "AZERBAIJAN - AZ", code: "AZ"},
    {name:"보스니아 헤르체고비나 - BA", name_en: "BOSNIA HERCEGOVINA - BA", code: "BA"},
    {name:"바베이도스 - BB", name_en: "BARBADOS - BB", code: "BB"},
    {name:"방글라데시 - BD", name_en: "BANGLADESH - BD", code: "BD"},
    {name:"벨기에 - BE", name_en: "BELGIUM - BE", code: "BE"},
    {name:"부르키나파소 - BF", name_en: "BURKINA FASO - BF", code: "BF"},
    {name:"불가리아 - BG", name_en: "BULGARIA - BG", code: "BG"},
    {name:"바레인 - BH", name_en: "BAHRAIN - BH", code: "BH"},
    {name:"브룬디 - BI", name_en: "BURUNDI - BI", code: "BI"},
    {name:"베냉 - BJ", name_en: "BENIN - BJ", code: "BJ"},
    {name:"버뮤다 - BM", name_en: "BERMUDA - BM", code: "BM"},
    {name:"브루나이 - BN", name_en: "BRUNEI DARUSSALAM - BN", code: "BN"},
    {name:"볼리비아 - BO", name_en: "BOLIVIA - BO", code: "BO"},
    {name:"보네르 - BQ", name_en: "BONAIRE - BQ", code: "BQ"},
    {name:"브라질 - BR", name_en: "BRAZIL - BR", code: "BR"},
    {name:"바하마 - BS", name_en: "BAHAMAS - BS", code: "BS"},
    {name:"부탄 - BT", name_en: "BHUTAN - BT", code: "BT"},
    {name:"보츠와나 - BW", name_en: "BOTSWANA - BW", code: "BW"},
    {name:"벨라루스 - BY", name_en: "BELARUS - BY", code: "BY"},
    {name:"벨리즈 - BZ", name_en: "BELIZE - BZ", code: "BZ"},
    {name:"콩고민주공화국 - CD", name_en: "Democratic Republic of the Congo - CD", code: "CD"},
    {name:"중앙아프리카공화국 - CF", name_en: "CENTRAL AFRICAN REPUBLIC - CF", code: "CF"},
    {name:"콩고 - CG", name_en: "CONGO - CG", code: "CG"},
    {name:"스위스 - CH", name_en: "SWITZERLAND - CH", code: "CH"},
    {name:"코트디부아르 - CI", name_en: "COTE D`IVOIRE - CI", code: "CI"},
    {name:"칠레 - CL", name_en: "CHILE - CL", code: "CL"},
    {name:"카메룬 - CM", name_en: "CAMEROON - CM", code: "CM"},
    {name:"콜롬비아 - CO", name_en: "COLOMBIA - CO", code: "CO"},
    {name:"코스타리카 - CR", name_en: "COSTA RICA - CR", code: "CR"},
    {name:"쿠바 - CU", name_en: "CUBA - CU", code: "CU"},
    {name:"카보베르데 - CV", name_en: "CAPE VERDE - CV", code: "CV"},
    {name:"큐라소 - CW", name_en: "CURACAO - CW", code: "CW"},
    {name:"사이프러스 - CY", name_en: "CYPRUS - CY", code: "CY"},
    {name:"체코공화국 - CZ", name_en: "CZECH REPUBLIC - CZ", code: "CZ"},
    {name:"지부티 - DJ", name_en: "DJIBOUTI - DJ", code: "DJ"},
    {name:"덴마크 - DK", name_en: "DENMARK - DK", code: "DK"},
    {name:"도미니카 연방 - DM", name_en: "DOMINICA - DM", code: "DM"},
    {name:"도미니카 공화국 - DO", name_en: "DOMINICAN REPUBLIC - DO", code: "DO"},
    {name:"알제리 - DZ", name_en: "ALGERIA - DZ", code: "DZ"},
    {name:"에콰도르 - EC", name_en: "ECUADOR - EC", code: "EC"},
    {name:"에스토니아 - EE", name_en: "ESTONIA - EE", code: "EE"},
    {name:"이집트 - EG", name_en: "EGYPT - EG", code: "EG"},
    {name:"서사하라 - EH", name_en: "WESTERN SAHARA - EH", code: "EH"},
    {name:"에리트레아 - ER", name_en: "ERITREA - ER", code: "ER"},
    {name:"스페인 - ES", name_en: "SPAIN - ES", code: "ES"},
    {name:"에티오피아 - ET", name_en: "ETHIOPIA - ET", code: "ET"},
    {name:"핀란드 - FI", name_en: "FINLAND - FI", code: "FI"},
    {name:"피지 - FJ", name_en: "FIJI - FJ", code: "FJ"},
    {name:"포클랜드섬 - FK", name_en: "FALKLAND ISLANDS - FK", code: "FK"},
    {name:"미크로네시아 - FM", name_en: "MICRONESIA - FM", code: "FM"},
    {name:"페로 군도 - FO", name_en: "FAROE ISLANDS - FO", code: "FO"},
    {name:"프랑스 - FR", name_en: "FRANCE - FR", code: "FR"},
    {name:"가봉 - GA", name_en: "GABON - GA", code: "GA"},
    {name:"그레나다 - GD", name_en: "GRENADA - GD", code: "GD"},
    {name:"조지아 - GE", name_en: "GEORGIA - GE", code: "GE"},
    {name:"건지 - GG", name_en: "GUERNSEY - GG", code: "GG"},
    {name:"가나 - GH", name_en: "GHANA - GH", code: "GH"},
    {name:"지브랄타 - GI", name_en: "GIBRALTAR - GI", code: "GI"},
    {name:"그린랜드 - GL", name_en: "GREENLAND - GL", code: "GL"},
    {name:"감비아 - GM", name_en: "GAMBIA - GM", code: "GM"},
    {name:"기니 - GN", name_en: "GUINEA - GN", code: "GN"},
    {name:"과들루프 - GP", name_en: "GUADELOUPE - GP", code: "GP"},
    {name:"적도 기니 - GQ", name_en: "EQUATORIAL GUINEA - GQ", code: "GQ"},
    {name:"그리스 - GR", name_en: "GREECE - GR", code: "GR"},
    {name:"과테말라 - GT", name_en: "GUATEMALA - GT", code: "GT"},
    {name:"괌 - GU", name_en: "GUAM - GU", code: "GU"},
    {name:"기네비쏘 - GW", name_en: "GUINEA-BISSAU - GW", code: "GW"},
    {name:"가이아나 - GY", name_en: "GUYANA - GY", code: "GY"},
    {name:"홍콩 - HK", name_en: "HONG KONG - HK", code: "HK"},
    {name:"온두라스 - HN", name_en: "HONDURAS - HN", code: "HN"},
    {name:"크로아티아 - HR", name_en: "CROATIA - HR", code: "HR"},
    {name:"아이티 - HT", name_en: "HAITI - HT", code: "HT"},
    {name:"헝가리 - HU", name_en: "HUNGARY - HU", code: "HU"},
    {name:"인도네시아 - ID", name_en: "INDONESIA - ID", code: "ID"},
    {name:"아일랜드 - IE", name_en: "IRELAND - IE", code: "IE"},
    {name:"이스라엘 - IL", name_en: "ISRAEL - IL", code: "IL"},
    {name:"맨섬 - IM", name_en: "ISLE OF MAN - IM", code: "IM"},
    {name:"인도 - IN", name_en: "INDIA - IN", code: "IN"},
    {name:"이라크 - IQ", name_en: "IRAQ - IQ", code: "IQ"},
    {name:"이란 - IR", name_en: "IRAN - IR", code: "IR"},
    {name:"아이슬란드 - IS", name_en: "ICELAND - IS", code: "IS"},
    {name:"저지 - JE", name_en: "JERSEY - JE", code: "JE"},
    {name:"자메이카 - JM", name_en: "JAMAICA - JM", code: "JM"},
    {name:"요르단 - JO", name_en: "JORDAN - JO", code: "JO"},
    
    {name:"케냐 - KE", name_en: "KENYA - KE", code: "KE"},
    {name:"키르기즈스탄 - KG", name_en: "KYRGYZSTAN - KG", code: "KG"},
    {name:"캄보디아 - KH", name_en: "CAMBODIA - KH", code: "KH"},
    {name:"키리바시 - KI", name_en: "KIRIBATI - KI", code: "KI"},
    {name:"코모르 - KM", name_en: "COMOROS - KM", code: "KM"},
    {name:"북한 - KP", name_en: "NORTH KOREA - KP", code: "KP"},
    {name:"코소보 - XK", name_en: "KOSOVO - XK", code: "XK"},
    {name:"쿠웨이트 - KW", name_en: "KUWAIT - KW", code: "KW"},
    {name:"카자흐스탄 - KZ", name_en: "KAZAKHSTAN - KZ", code: "KZ"},
    {name:"라오스 - LA", name_en: "LAOS - LA", code: "LA"},
    {name:"레바논 - LB", name_en: "LEBANON - LB", code: "LB"},
    {name:"리히텐슈타인 - LI", name_en: "LIECHTENSTEIN - LI", code: "LI"},
    {name:"스리랑카 - LK", name_en: "SRI LANKA - LK", code: "LK"},
    {name:"라이베리아 - LR", name_en: "LIBERIA - LR", code: "LR"},
    {name:"레소토 - LS", name_en: "LESOTHO - LS", code: "LS"},
    {name:"리투아니아 - LT", name_en: "LITHUANIA - LT", code: "LT"},
    {name:"룩셈부르크 - LU", name_en: "LUXEMBOURG - LU", code: "LU"},
    {name:"라트비아 - LV", name_en: "LATVIA - LV", code: "LV"},
    {name:"리비아 - LY", name_en: "LIBYAN ARAB JAMAHIRIYA - LY", code: "LY"},
    {name:"모로코 - MA", name_en: "MOROCCO - MA", code: "MA"},
    {name:"모나코 - MC", name_en: "MONACO - MC", code: "MC"},
    {name:"몰도바 - MD", name_en: "MOLDOVA - MD", code: "MD"},
    {name:"마다가스카르 - MG", name_en: "MADAGASCAR - MG", code: "MG"},
    {name:"마샬군도 - MH", name_en: "MARSHALL ISLANDS - MH", code: "MH"},
    {name:"마케도니아 - MK", name_en: "MACEDONIA - MK", code: "MK"},
    {name:"말리 - ML", name_en: "MALI - ML", code: "ML"},
    {name:"미얀마 - MM", name_en: "MYANMAR - MM", code: "MM"},
    {name:"몽골 - MN", name_en: "MONGOLIA - MN", code: "MN"},
    {name:"마카오 - MO", name_en: "MACAU - MO", code: "MO"},
    {name:"마르티니크 - MQ", name_en: "MARTINIQUE - MQ", code: "MQ"},
    {name:"모리타니 - MR", name_en: "MAURITANIA - MR", code: "MR"},
    {name:"몬트세라트 - MS", name_en: "MONTSERRAT - MS", code: "MS"},
    {name:"몰타 - MT", name_en: "MALTA - MT", code: "MT"},
    {name:"모리셔스 - MU", name_en: "MAURITIUS - MU", code: "MU"},
    {name:"몰디브 - MV", name_en: "MALDIVES - MV", code: "MV"},
    {name:"말라위 - MW", name_en: "MALAWI - MW", code: "MW"},
    {name:"멕시코 - MX", name_en: "MEXICO - MX", code: "MX"},
    {name:"말레이시아 - MY", name_en: "MALAYSIA - MY", code: "MY"},
    {name:"모잠비크 - MZ", name_en: "MOZAMBIQUE - MZ", code: "MZ"},
    {name:"나미비아 - NA", name_en: "NAMIBIA - NA", code: "NA"},
    {name:"뉴칼레도니아 - NC", name_en: "NEW CALEDONIA - NC", code: "NC"},
    {name:"니제르 - NE", name_en: "NIGER - NE", code: "NE"},
    {name:"나이지리아 - NG", name_en: "NIGERIA - NG", code: "NG"},
    {name:"니카라과 - NI", name_en: "NICARAGUA - NI", code: "NI"},
    {name:"노르웨이 - NO", name_en: "NORWAY - NO", code: "NO"},
    {name:"네팔 - NP", name_en: "NEPAL - NP", code: "NP"},
    {name:"나우루 - NR", name_en: "NAURU - NR", code: "NR"},
    {name:"니우에 - NU", name_en: "NIUE - NU", code: "NU"},
    {name:"뉴질랜드 - NZ", name_en: "NEW ZEALAND - NZ", code: "NZ"},
    {name:"오만 - OM", name_en: "OMAN - OM", code: "OM"},
    {name:"파나마 - PA", name_en: "PANAMA - PA", code: "PA"},
    {name:"페루 - PE", name_en: "PERU - PE", code: "PE"},
    {name:"파푸아뉴기니 - PG", name_en: "PAPUANEWGUINEA - PG", code: "PG"},
    {name:"필리핀 - PH", name_en: "PHILIPPINES - PH", code: "PH"},
    {name:"파키스탄 - PK", name_en: "PAKISTAN - PK", code: "PK"},
    {name:"핏케언 군도 - PN", name_en: "PITCAIRN - PN", code: "PN"},
    {name:"푸에르토리코 - PR", name_en: "PUERTO RICO - PR", code: "PR"},
    {name:"팔레스타인 - PS", name_en: "PALESTINE - PS", code: "PS"},
    {name:"포르투갈 - PT", name_en: "PORTUGAL - PT", code: "PT"},
    {name:"팔라우 - PW", name_en: "PALAU - PW", code: "PW"},
    {name:"파라과이 - PY", name_en: "PARAGUAY - PY", code: "PY"},
    {name:"카타르 - QA", name_en: "QATAR - QA", code: "QA"},
    {name:"리유니언 - RE", name_en: "REUNION - RE", code: "RE"},
    {name:"세르비아 - RS", name_en: "SERBIA - RS", code: "RS"},
    {name:"러시아 - RU", name_en: "RUSSIAN FEDERATION - RU", code: "RU"},
    {name:"르완다 - RW", name_en: "RWANDA - RW", code: "RW"},
    {name:"사우디아라비아 - SA", name_en: "SAUDI ARABIA - SA", code: "SA"},
    {name:"솔로몬 군도 - SB", name_en: "SOLOMON ISLANDS - SB", code: "SB"},
    {name:"이셸 - SC", name_en: "SEYCHELLES - SC", code: "SC"},
    {name:"수단 - SD", name_en: "SUDAN - SD", code: "SD"},
    {name:"스웨덴 - SE", name_en: "SWEDEN - SE", code: "SE"},
    {name:"싱가포르 - SG", name_en: "SINGAPORE - SG", code: "SG"},
    {name:"세인트 헬레나 - SH", name_en: "SAINT HELENA - SH", code: "SH"},
    {name:"슬로베니아 - SI", name_en: "SLOVENIA - SI", code: "SI"},
    {name:"슬로바키아 - SK", name_en: "SLOVAKIA - SK", code: "SK"},
    {name:"시에라리온 - SL", name_en: "SIERRA LEONE - SL", code: "SL"},
    {name:"산마리노 - SM", name_en: "SAN MARINO - SM", code: "SM"},
    {name:"세네갈 - SN", name_en: "SENEGAL - SN", code: "SN"},
    {name:"소말리아 - SO", name_en: "SOMALIA - SO", code: "SO"},
    {name:"수리남 - SR", name_en: "SURINAME - SR", code: "SR"},
    {name:"남수단 - SS", name_en: "SOUTH SUDAN - SS", code: "SS"},
    {name:"엘살바도르 - SV", name_en: "EL SALVADOR - SV", code: "SV"},
    {name:"시리아 - SY", name_en: "SYRIAN ARAB REPUBLIC - SY", code: "SY"},
    {name:"스와질랜드 - SZ", name_en: "SWAZILAND - SZ", code: "SZ"},
    {name:"차드 - TD", name_en: "CHAD - TD", code: "TD"},
    {name:"토고 - TG", name_en: "TOGO - TG", code: "TG"},
    {name:"태국 - TH", name_en: "THAILAND - TH", code: "TH"},
    {name:"타지키스탄 - TJ", name_en: "TAJIKISTAN - TJ", code: "TJ"},
    {name:"토켈라우 - TK", name_en: "TOKELAU - TK", code: "TK"},
    {name:"동티모르 - TL", name_en: "EAST TIMOR - TL", code: "TL"},
    {name:"투르크메니스탄 - TM", name_en: "TURKMENISTAN - TM", code: "TM"},
    {name:"튀니지 - TN", name_en: "TUNISIA - TN", code: "TN"},
    {name:"통가 - TO", name_en: "TONGA - TO", code: "TO"},
    {name:"터키 - TR", name_en: "TURKEY - TR", code: "TR"},
    {name:"트리니다드토바고 - TT", name_en: "TRINIDAD AND TOBAGO - TT", code: "TT"},
    {name:"투발루 - TV", name_en: "TUVALU - TV", code: "TV"},
    {name:"대만 - TW", name_en: "TAIWAN - TW", code: "TW"},
    {name:"탄자니아 - TZ", name_en: "TANZANIA - TZ", code: "TZ"},
    {name:"우크라이나 - UA", name_en: "UKRAINE - UA", code: "UA"},
    {name:"우간다 - UG", name_en: "UGANDA - UG", code: "UG"},
    {name:"우루과이 - UY", name_en: "URUGUAY - UY", code: "UY"},
    {name:"우즈베키스탄 - UZ", name_en: "UZBEKISTAN - UZ", code: "UZ"},
    {name:"바티칸 - VA", name_en: "VATICAN CITY STATE - VA", code: "VA"},
    {name:"세인트 빈센트 그레나딘스 - VC", name_en: "SAINT VINCENT AND THE GRENADINES - VC", code: "VC"},
    {name:"베네수엘라 - VE", name_en: "VENEZUELA - VE", code: "VE"},
    {name:"베트남 - VN", name_en: "VIET NAM - VN", code: "VN"},
    {name:"바누아투 - VU", name_en: "VANUATU - VU", code: "VU"},
    {name:"사모아 - WS", name_en: "SAMOA - WS", code: "WS"},
    {name:"예멘 - YE", name_en: "YEMEN - YE", code: "YE"},
    {name:"마요트 - YT", name_en: "MAYOTTE - YT", code: "YT"},
    {name:"유고슬라비아 - YU", name_en: "YUGOSLAVIA - YU", code: "YU"},
    {name:"남아프리카공화국 - ZA", name_en: "SOUTH AFRICA - ZA", code: "ZA"},
    {name:"잠비아 - ZM", name_en: "ZAMBIA - ZM", code: "ZM"},
    {name:"자이르 - ZR", name_en: "ZAIRE - ZR", code: "ZR"},
    {name:"짐바브웨 - ZW", name_en: "ZIMBABWE - ZW", code: "ZW"},
    
    {name:"아메리칸 사모아 - AS ", name_en: "AMERICAN SAMOA", code: "AS"},
    {name:"부베섬 - BV ", name_en: "BOUVET ISLAND", code: "BV"},
    {name:'영인도 제도 - IO ', name_en: 'BRITISH INDIAN OCEAN TERRITORY', code: 'IO'},
    {name:'케이맨 제도 - KY ', name_en: 'CAYMAN ISLANDS', code: 'KY'},
    {name:'크리스마스 섬 - CX ', name_en: 'CHRISTMAS ISLAND', code: 'CX'},
    {name:'코코스 제도 - CC ', name_en: 'COCOS ISLANDS', code: 'CC'},
    {name:'쿡 제도 - CK ', name_en: 'COOK ISLANDS ', code: 'CK'},
    {name:'프랑스령 기아나 - GF ', name_en: 'FRENCH GUIANA', code: 'GF'},
    {name:'프랑스령 폴리네시아 - PF ', name_en: 'FRENCH POLYNESIA', code: 'PF'},
    {name:'프랑스령 남방  및 남극 지역 - TF ', name_en: 'FRENCH SOUTHERN TERRITORIES ', code: 'TF'},
    {name:'허드 맥도널드 제도 - HM ', name_en: 'HEARD ISLAND AND MCDONALD ISLANDS', code: 'HM'},
    {name:'몬테네그로 - ME ', name_en: 'MONTENEGRO', code: 'ME'},
    {name:'노퍽섬 - NF ', name_en: 'NORFOLK ISLAND', code: 'NF'},
    {name:'북마리아나 제도 - MP ', name_en: 'NORTHERN MARIANA ISLANDS', code: 'MP'},
    {name:'생바르텔레미 - BL ', name_en: 'SAINT BARTHÉLEMY', code: 'BL'},
    {name:'세인트키츠 네비스 - KN ', name_en: 'SAINT KITTS AND NEVIS', code: 'KN'},
    {name:'세인트루시아 - LC ', name_en: 'SAINT LUCIA', code: 'LC'},
    {name:'생마르탱 - MF ', name_en: 'SAINT MARTIN (FRENCH PART)', code: 'MF'},
    {name:'생피에르  미클롱 - PM ', name_en: 'SAINT PIERRE AND MIQUELON', code: 'PM'},
    {name:'상투메 프린시페 - ST ', name_en: 'SAO TOME AND PRINCIPE', code: 'ST'},
    {name:'신트마르턴 - SX ', name_en: 'SINT MAARTEN (DUTCH PART)', code: 'SX'},
    {name:'사우스조지아 사우스샌드위치 제도 - GS ', name_en: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS', code: 'GS'},
    {name:'스발마르 얀마옌 - SJ ', name_en: 'SVALBARD', code: 'SJ'},
    {name:'터크스 케이커스 제도 - TC ', name_en: 'TURKS AND CAICOS ISLANDS ', code: 'TC'},
    {name:'미국령 군소 제도 - UM ', name_en: 'UNITED STATES MINOR OUTLYING ISLANDS', code: 'UM'},
    {name:'영국령 버진아일랜드 - VG ', name_en: 'VIRGIN ISLANDS (BRITISH) ', code: 'VG'},
    {name:'미국령 버진아일랜드 - VI ', name_en: 'VIRGIN ISLANDS (U.S.)', code: 'VI'},
    {name:'왈리스 푸투나 - WF ', name_en: 'WALLIS AND FUTUNA', code: 'WF'},
]
// 국가번호
const dialing = [
    {name:"대한민국 +82", name_en: "SOUTH KOREA", code: "+82"},
    {name:"미국 +1", name_en: "UNITED STATES", code: "+1"},
    {name:"영국 +44", name_en: "UNITED KINGDOM", code: "+44"},
    {name:"캐나다 +1", name_en: "CANADA", code: "+1"},
    {name:"네덜란드 +31", name_en: "NETHERLANDS", code: "+31"},
    {name:"호주 +61", name_en: "AUSTRALIA", code: "+61"},
    {name:"독일 +49", name_en: "GERMANY", code: "+49"},
    {name:"이탈리아 +39", name_en: "ITALY", code: "+39"},
    {name:"안도라 +376", name_en: "ANDORRA", code: "+376"},
    {name:"아랍에미리트 +971", name_en: "UNITED ARAB EMIRATES", code: "+971"},
    {name:"아프가니스탄 +93", name_en: "AFGHANISTAN", code: "+93"},
    {name:"안티구아 바부다 +1 268", name_en: "ANTIGUA AND BARBUDA", code: "+1 268"},
    {name:"앙길라 +1 264", name_en: "ANGUILLA", code: "+1 264"},
    {name:"알바니아 +355", name_en: "ALBANIA", code: "+355"},
    {name:"아르메니아 +374", name_en: "ARMENIA", code: "+374"},
    {name:"앙골라 +244", name_en: "ANGOLA", code: "+244"},
    {name:"안타티카 +672", name_en: "ANTARCTICA", code: "+672"},
    {name:"아르헨티나 +54", name_en: "ARGENTINA", code: "+54"},
    {name:"오스트리아 +43", name_en: "AUSTRIA", code: "+43"},
    {name:"아루바 +297", name_en: "ARUBA", code: "+297"},
    {name:"알랜드 군도 +3 18", name_en: "ALAND ISLANDS", code: "+358 18"},
    {name:"아제르바이잔 +994", name_en: "AZERBAIJAN", code: "+994"},
    {name:"보스니아 헤르체고비나 +387", name_en: "BOSNIA HERCEGOVINA", code: "+387"},
    {name:"바베이도스  +246", name_en: "BARBADOS", code: "+1 246"},
    {name:"방글라데시 +880", name_en: "BANGLADESH", code: "+880"},
    {name:"벨기에 +32", name_en: "BELGIUM", code: "+32"},
    {name:"부르키나파소 +226", name_en: "BURKINA FASO", code: "+226"},
    {name:"불가리아 +359", name_en: "BULGARIA", code: "+359"},
    {name:"바레인 +973", name_en: "BAHRAIN", code: "+973"},
    {name:"브룬디 +257", name_en: "BURUNDI", code: "+257"},
    {name:"베냉 +229", name_en: "BENIN", code: "+229"},
    {name:"버뮤다 +1 441", name_en: "BERMUDA", code: "+1 441"},
    {name:"브루나이 +673", name_en: "BRUNEI DARUSSALAM", code: "+673"},
    {name:"볼리비아 +591", name_en: "BOLIVIA", code: "+591"},
    {name:"보네르 +599 7", name_en: "BONAIRE", code: "+599 7"},
    {name:"브라질 +55", name_en: "BRAZIL", code: "+55"},
    {name:"바하마  +1 242", name_en: "BAHAMAS", code: "+1 242"},
    {name:"부탄 +975", name_en: "BHUTAN", code: "+975"},
    {name:"보츠와나 +267", name_en: "BOTSWANA", code: "+267"},
    {name:"벨라루스 +375", name_en: "BELARUS", code: "+375"},
    {name:"벨리즈 +501", name_en: "BELIZE", code: "+501"},
    {name:"콩고민주공화국 +243", name_en: "Democratic Republic of the Congo", code: "+243"},
    {name:"중앙아프리카공화국 +236", name_en: "CENTRAL AFRICAN REPUBLIC", code: "+236"},
    {name:"콩고 +242", name_en: "CONGO", code: "+242"},
    {name:"스위스 +41", name_en: "SWITZERLAND", code: "+41"},
    {name:"코트디부아르 +225", name_en: "COTE D`IVOIRE", code: "+225"},
    {name:"칠레 +56", name_en: "CHILE", code: "+56"},
    {name:"카메룬 +237", name_en: "CAMEROON", code: "+237"},
    {name:"중국 +86", name_en: "CHINA", code: "+86"},
    {name:"콜롬비아 +57", name_en: "COLOMBIA", code: "+57"},
    {name:"코스타리카 +506", name_en: "COSTA RICA", code: "+506"},
    {name:"쿠바 +53", name_en: "CUBA", code: "+53"},
    {name:"카보베르데 +238", name_en: "CAPE VERDE", code: "+238"},
    {name:"큐라소 +599 9", name_en: "CURACAO", code: "+599 9"},
    {name:"사이프러스 +357", name_en: "CYPRUS", code: "+357"},
    {name:"체코공화국 +420", name_en: "CZECH REPUBLIC", code: "+420"},
    {name:"지부티 +253", name_en: "DJIBOUTI", code: "+253"},
    {name:"덴마크 +45", name_en: "DENMARK", code: "+45"},
    {name:"도미니카 연방 +1 767", name_en: "DOMINICA", code: "+1 767"},
    {name:"도미니카 공화국 +1 809", name_en: "DOMINICAN REPUBLIC", code: "+1 809"},
    {name:"알제리  +1 213", name_en: "ALGERIA", code: "+1 213"},
    {name:"에콰도르 +593", name_en: "ECUADOR", code: "+593"},
    {name:"에스토니아 +372", name_en: "ESTONIA", code: "+372"},
    {name:"이집트 +20", name_en: "EGYPT", code: "+20"},
    {name:"서사하라 +212", name_en: "WESTERN SAHARA", code: "+212"},
    {name:"에리트레아 +291", name_en: "ERITREA", code: "+291"},
    {name:"스페인 +34", name_en: "SPAIN", code: "+34"},
    {name:"에티오피아 +251", name_en: "ETHIOPIA", code: "+251"},
    {name:"핀란드 +358", name_en: "FINLAND", code: "+358"},
    {name:"피지 +679", name_en: "FIJI", code: "+679"},
    {name:"포클랜드섬 +500", name_en: "FALKLAND ISLANDS", code: "+500"},
    {name:"미크로네시아 +691", name_en: "MICRONESIA", code: "+691"},
    {name:"페로 군도 +298", name_en: "FAROE ISLANDS", code: "+298"},
    {name:"프랑스 +33", name_en: "FRANCE", code: "+33"},
    {name:"가봉 +241", name_en: "GABON", code: "+241"},
    {name:"그레나다 +1 473", name_en: "GRENADA", code: "+1 473"},
    {name:"조지아 +995", name_en: "GEORGIA", code: "+995"},
    {name:"건지 +44 1481", name_en: "GUERNSEY", code: "+44 1481"},
    {name:"가나 +233", name_en: "GHANA", code: "+233"},
    {name:"지브랄타 +350", name_en: "GIBRALTAR", code: "+350"},
    {name:"그린랜드 +299", name_en: "GREENLAND", code: "+299"},
    {name:"감비아 +220", name_en: "GAMBIA", code: "+220"},
    {name:"기니 +218", name_en: "GUINEA", code: "+218"},
    {name:"과들루프 +590", name_en: "GUADELOUPE", code: "+590"},
    {name:"적도 기니 +240", name_en: "EQUATORIAL GUINEA", code: "+240"},
    {name:"그리스 +30", name_en: "GREECE", code: "+30"},
    {name:"과테말라 +502", name_en: "GUATEMALA", code: "+502"},
    {name:"괌 +1 671", name_en: "GUAM", code: "+1 671"},
    {name:"기네비쏘 +245", name_en: "GUINEA-BISSAU", code: "+245"},
    {name:"가이아나 +592", name_en: "GUYANA", code: "+592"},
    {name:"홍콩 +852", name_en: "HONG KONG", code: "+852"},
    {name:"온두라스 +504", name_en: "HONDURAS", code: "+504"},
    {name:"크로아티아 +385", name_en: "CROATIA", code: "+385"},
    {name:"아이티 +509", name_en: "HAITI", code: "+509"},
    {name:"헝가리 +36", name_en: "HUNGARY", code: "+36"},
    {name:"인도네시아 +62", name_en: "INDONESIA", code: "+62"},
    {name:"아일랜드 +353", name_en: "IRELAND", code: "+353"},
    {name:"이스라엘 +972", name_en: "ISRAEL", code: "+972"},
    {name:"맨섬 +421", name_en: "ISLE OF MAN", code: "+421"},
    {name:"인도 +91", name_en: "INDIA", code: "+91"},
    {name:"이라크 +964", name_en: "IRAQ", code: "+964"},
    {name:"이란 +98", name_en: "IRAN", code: "+98"},
    {name:"아이슬란드 +354", name_en: "ICELAND", code: "+354"},
    {name:"저지 +44 1534", name_en: "JERSEY", code: "+44 1534"},
    {name:"자메이카 +1 876", name_en: "JAMAICA", code: "+1 876"},
    {name:"요르단 +962", name_en: "JORDAN", code: "+962"},
    {name:"일본 +81", name_en: "JAPAN", code: "+81"},
    {name:"케냐 +254", name_en: "KENYA", code: "+254"},
    {name:"키르기즈스탄 +996", name_en: "KYRGYZSTAN", code: "+996"},
    {name:"캄보디아 +855", name_en: "CAMBODIA", code: "+855"},
    {name:"키리바시 +686", name_en: "KIRIBATI", code: "+686"},
    {name:"코모르 +269", name_en: "COMOROS", code: "+269"},
    {name:"북한 +850", name_en: "NORTH KOREA", code: "+850"},
    {name:"코소보 +383", name_en: "KOSOVO", code: "+383"},
    {name:"쿠웨이트 +965", name_en: "KUWAIT", code: "+965"},
    {name:"카자흐스탄 +7", name_en: "KAZAKHSTAN", code: "+7"},
    {name:"라오스 +856", name_en: "LAOS", code: "+856"},
    {name:"레바논 +961", name_en: "LEBANON", code: "+961"},
    {name:"리히텐슈타인 +423", name_en: "LIECHTENSTEIN", code: "+423"},
    {name:"스리랑카 +94", name_en: "SRI LANKA", code: "+94"},
    {name:"라이베리아 +231", name_en: "LIBERIA", code: "+231"},
    {name:"레소토 +266", name_en: "LESOTHO", code: "+266"},
    {name:"리투아니아 +370", name_en: "LITHUANIA", code: "+370"},
    {name:"룩셈부르크 +352", name_en: "LUXEMBOURG", code: "+352"},
    {name:"라트비아 +371", name_en: "LATVIA", code: "+371"},
    {name:"리비아 +218", name_en: "LIBYAN ARAB JAMAHIRIYA", code: "+218"},
    {name:"모로코 +212", name_en: "MOROCCO", code: "+212"},
    {name:"모나코 +377", name_en: "MONACO", code: "+377"},
    {name:"몰도바 +373", name_en: "MOLDOVA", code: "+373"},
    {name:"마다가스카르 +261", name_en: "MADAGASCAR", code: "+261"},
    {name:"마샬군도 +692", name_en: "MARSHALL ISLANDS", code: "+692"},
    {name:"마케도니아 +389", name_en: "MACEDONIA", code: "+389"},
    {name:"말리 +223", name_en: "MALI", code: "+223"},
    {name:"미얀마 +95", name_en: "MYANMAR", code: "+95"},
    {name:"몽골 +976", name_en: "MONGOLIA", code: "+976"},
    {name:"마카오 +853", name_en: "MACAU", code: "+853"},
    {name:"마르티니크 +596", name_en: "MARTINIQUE", code: "+596"},
    {name:"모리타니 +222", name_en: "MAURITANIA", code: "+222"},
    {name:"몬트세라트  664", name_en: "MONTSERRAT", code: "+1 664"},
    {name:"몰타 +356", name_en: "MALTA", code: "+356"},
    {name:"모리셔스 +230", name_en: "MAURITIUS", code: "+230"},
    {name:"몰디브 +960", name_en: "MALDIVES", code: "+960"},
    {name:"말라위 +265", name_en: "MALAWI", code: "+265"},
    {name:"멕시코 +52", name_en: "MEXICO", code: "+52"},
    {name:"말레이시아 +60", name_en: "MALAYSIA", code: "+60"},
    {name:"모잠비크 +258", name_en: "MOZAMBIQUE", code: "+258"},
    {name:"나미비아 +264", name_en: "NAMIBIA", code: "+264"},
    {name:"뉴칼레도니아 +687", name_en: "NEW CALEDONIA", code: "+687"},
    {name:"니제르 +227", name_en: "NIGER", code: "+227"},
    {name:"나이지리아 +234", name_en: "NIGERIA", code: "+234"},
    {name:"니카라과 +505", name_en: "NICARAGUA", code: "+505"},

    
    {name:"노르웨이 +47", name_en: "NORWAY", code: "+47"},
    {name:"네팔 +977", name_en: "NEPAL", code: "+977"},
    {name:"나우루 +674", name_en: "NAURU", code: "+674"},
    {name:"니우에 +683", name_en: "NIUE", code: "+683"},
    {name:"뉴질랜드 +64", name_en: "NEW ZEALAND", code: "+64"},
    {name:"오만 +968", name_en: "OMAN", code: "+968"},
    {name:"파나마 +507", name_en: "PANAMA", code: "+507"},
    {name:"페루 +51", name_en: "PERU", code: "+51"},
    {name:"파푸아뉴기니 +675", name_en: "PAPUANEWGUINEA", code: "+675"},
    {name:"필리핀 +63", name_en: "PHILIPPINES", code: "+63"},
    {name:"파키스탄 +92", name_en: "PAKISTAN", code: "+92"},
    {name:"폴란드 +44 1534", name_en: "POLAND", code: "+44 1534"},
    {name:"핏케언 군도 +64", name_en: "PITCAIRN", code: "+64"},
    {name:"푸에르토리코 +1 787", name_en: "PUERTO RICO", code: "+1 787"},
    {name:"팔레스타인 +970", name_en: "PALESTINE", code: "+970"},
    {name:"포르투갈 +351", name_en: "PORTUGAL", code: "+351"},
    {name:"팔라우 +680", name_en: "PALAU", code: "+680"},
    {name:"파라과이 +595", name_en: "PARAGUAY", code: "+595"},
    {name:"카타르 +974", name_en: "QATAR", code: "+974"},
    {name:"리유니언 +262", name_en: "REUNION", code: "+262"},
    {name:"루마니아 +40", name_en: "ROMANIA", code: "+40"},
    {name:"세르비아 +381", name_en: "SERBIA", code: "+381"},
    {name:"러시아 +7", name_en: "RUSSIAN FEDERATION", code: "+7"},
    {name:"르완다 +250", name_en: "RWANDA", code: "+250"},
    {name:"사우디아라비아 +966", name_en: "SAUDI ARABIA", code: "+966"},
    {name:"솔로몬 군도 +677", name_en: "SOLOMON ISLANDS", code: "+677"},
    {name:"이셸 +248", name_en: "SEYCHELLES", code: "+248"},
    {name:"수단 +249", name_en: "SUDAN", code: "+249"},
    {name:"스웨덴 +46", name_en: "SWEDEN", code: "+46"},
    {name:"싱가포르 +65", name_en: "SINGAPORE", code: "+65"},
    {name:"세인트 헬레나 +290", name_en: "SAINT HELENA", code: "+290"},
    {name:"슬로베니아 +386", name_en: "SLOVENIA", code: "+386"},
    {name:"슬로바키아 +421", name_en: "SLOVAKIA", code: "+421"},
    {name:"시에라리온 +232", name_en: "SIERRA LEONE", code: "+232"},
    {name:"산마리노 +378", name_en: "SAN MARINO", code: "+378"},
    {name:"세네갈 +221", name_en: "SENEGAL", code: "+221"},
    {name:"소말리아 +252", name_en: "SOMALIA", code: "+252"},
    {name:"수리남 +597", name_en: "SURINAME", code: "+597"},
    {name:"남수단 +211", name_en: "SOUTH SUDAN", code: "+211"},
    {name:"엘살바도르 +503", name_en: "EL SALVADOR", code: "+503"},
    {name:"시리아 +963", name_en: "SYRIAN ARAB REPUBLIC", code: "+963"},
    {name:"스와질랜드 +268", name_en: "SWAZILAND", code: "+268"},
    {name:"차드 +235", name_en: "CHAD", code: "+235"},
    {name:"토고 +228", name_en: "TOGO", code: "+228"},
    {name:"태국 +66", name_en: "THAILAND", code: "+66"},
    {name:"타지키스탄 +992", name_en: "TAJIKISTAN", code: "+992"},
    {name:"토켈라우 +690", name_en: "TOKELAU", code: "+690"},
    {name:"동티모르 +670", name_en: "EAST TIMOR", code: "+670"},
    {name:"투르크메니스탄 +993", name_en: "TURKMENISTAN", code: "+993"},
    {name:"튀니지 +1 216", name_en: "TUNISIA", code: "+1 216"},
    {name:"통가 +676", name_en: "TONGA", code: "+676"},
    {name:"터키 +90", name_en: "TURKEY", code: "+90"},
    {name:"트리니다드토바고 +868", name_en: "TRINIDAD AND TOBAGO", code: "+868"},
    {name:"투발루 +688", name_en: "TUVALU", code: "+688"},
    {name:"대만 +886", name_en: "TAIWAN", code: "+886"},
    {name:"탄자니아 +255", name_en: "TANZANIA", code: "+255"},
    {name:"우크라이나 +380", name_en: "UKRAINE", code: "+380"},
    {name:"우간다 +256", name_en: "UGANDA", code: "+256"},
    {name:"우루과이 +598", name_en: "URUGUAY", code: "+598"},
    {name:"우즈베키스탄 +998", name_en: "UZBEKISTAN", code: "+998"},
    {name:"바티칸 +379", name_en: "VATICAN CITY STATE", code: "+379"},
    {name:"세인트 빈센트 그레나딘스 +1 784", name_en: "SAINT VINCENT AND THE GRENADINES", code: "+1 784"},
    {name:"베네수엘라 +52", name_en: "VENEZUELA", code: "+52"},
    {name:"베트남 +84", name_en: "VIET NAM", code: "+84"},
    {name:"바누아투 +678", name_en: "VANUATU", code: "+678"},
    {name:"사모아 +685", name_en: "SAMOA", code: "+685"},
    {name:"예멘 +967", name_en: "YEMEN", code: "+967"},
    {name:"마요트 +269", name_en: "MAYOTTE", code: "+269"},
    {name:"유고슬라비아 +38", name_en: "YUGOSLAVIA", code: "+38"},
    {name:"남아프리카공화국 +27", name_en: "SOUTH AFRICA", code: "+27"},
    {name:"잠비아 +260", name_en: "ZAMBIA", code: "+260"},
    {name:"자이르 +243", name_en: "ZAIRE", code: "+243"},
    {name:"짐바브웨 +263", name_en: "ZIMBABWE", code: "+263"},
    {name:"국적불명", name_en: "UNKNOWN", code: ""}
]
// 국가 언어
export const language = Object.freeze([
    {"code":"ko","name":"한국어 - KO","en_name":"Korean - KO","original":"한국어"},
    {"code":"en","name":"영어 - EN","en_name":"English - EN","original":"English"},
    {"code":"zh","name":"중국어 - ZH","en_name":"Chinese - ZH","original":"中文"},
    {"code":"zh-Hans","name":"중국어(간체) - ZH-Hans","en_name":"Chinese (Simplified) - ZH-Hans","original":"中文"},
    {"code":"zh-Hant","name":"중국어(번체) - ZH-Hant","en_name":"Chinese (Tranditional) - ZH-Hant","original":"中文"},
    {"code":"yue-Hant","name":"중국어(광동어) - yue-Hant","en_name":"Chinese (Cantonese) - yue-Hant","original":"廣東話"},
    {"code":"hi","name":"힌디어 - HI","en_name":"Hindi - HI","original":"हिन्दी"},
    {"code":"es","name":"스페인어 - ES","en_name":"Spanish - ES","original":"Espanol"},
    {"code":"fr","name":"프랑스어 - FR","en_name":"French - FR","original":"Le français"},
    {"code":"ar","name":"아랍어 - AR","en_name":"Arabic - AR","original":"العربية"},
    {"code":"bn","name":"벵골어 - BN","en_name":"Bengali - BN","original":"বাংলা"},
    {"code":"ru","name":"러시아어 - RU","en_name":"Russian - RU","original":"русский"},
    {"code":"pt","name":"포르투칼어 - PT","en_name":"Portuguese - PT","original":"Português"},
    {"code":"ur","name":"우르두어 - UR","en_name":"Urdu - UR","original":"اُردُو"},
    {"code":"id","name":"인도네시아어 - ID","en_name":"Indonesian - ID","original":"bahasa"},
    {"code":"de","name":"독일어 - DE","en_name":"German - DE","original":"Deutsch"},
    {"code":"ja","name":"일본어 - JA","en_name":"Japanese - JA","original":"日本語"},
    {"code":"mr","name":"마라타어 - MR","en_name":"Marathi - MR","original":"मराठी"},
    {"code":"te","name":"텔루구어 - TE","en_name":"Telugu - TE","original":"తెలుగు"},
    {"code":"tr","name":"터키어 - TR","en_name":"Turkish - TR","original":"Türk"},
    {"code":"ta","name":"타밀어 - TA","en_name":"Tamil - TA","original":"Tamil"},
    {"code":"vi","name":"베트남어 - VI","en_name":"Vietnamese - VI","original":"tiếng Việt"},
    {"code":"nl","name":"네덜란드어 - NL","en_name":"Dutch - NL","original":"Nederlands"},
    {"code":"bg","name":"불가리아어 - BG","en_name":"Bulgarian - BG","original":"български"},
    {"code":"cs","name":"체코어 - CS","en_name":"Czech - CS","original":"Česky"},
    {"code":"da","name":"덴마크어 - DA","en_name":"Danish - DA","original":"Dansk"},
    {"code":"el","name":"그리스어 - EL","en_name":"Greek - EL","original":"Ελληνικά"},
    {"code":"et","name":"에스토니아어 - ET","en_name":"Estonian - ET","original":"Eestlane"},
    {"code":"fi","name":"필란드어 - FI","en_name":"Finnish - FI","original":"Suomen kielen"},
    {"code":"ga","name":"아일랜드어 - GA","en_name":"Irish - GA","original":"Gaeilge"},
    {"code":"he","name":"히브리어 - HE","en_name":"Hebrew - HE","original":"עברית"},
    {"code":"hr","name":"크로아티아어 - HR","en_name":"Croatian - HR","original":"hrvatski"},
    {"code":"hu","name":"헝가리어 - HU","en_name":"Hungarian - HU","original":"magyar"},
    {"code":"it","name":"이탈리아어 - IT","en_name":"Italian - IT","original":"italiano"},
    {"code":"lt","name":"리투아니아어 - LT","en_name":"Lithuanian - LT","original":"Lietuvis"},
    {"code":"lv","name":"라트비아어 - LV","en_name":"Latvian - LV","original":"Latvietis"},
    {"code":"no","name":"노르웨이어 - NO","en_name":"Norwegian - NO","original":"Norsk"},
    {"code":"pl","name":"폴란드어 - PL","en_name":"Polish - PL","original":"Polski"},
    {"code":"ro","name":"루마니아어 - RO","en_name":"Romanian - RO","original":"românesc"},
    {"code":"sk","name":"슬로바키아어 - SK","en_name":"Slovak - SK","original":"slovenský"},
    {"code":"sl","name":"슬로베니아어 - SL","en_name":"Slovenian - SL","original":"Slovensko"},
    {"code":"sr","name":"세르비아어 - SR","en_name":"Serbian - SR","original":"Српски"},
    {"code":"sv","name":"스웨덴어 - SV","en_name":"Swedish - SV","original":"Svenska"},
    {"code":"th","name":"태국어 - TH","en_name":"Thai - TH","original":"ไทย"},
    {"code":"uk","name":"우크라이나어 - UK","en_name":"Ukrainian - UK","original":"Українська"},
    {"code":"aa","name":"Afar - AA","en_name":"Afar - AA","original":"Afar"},
    {"code":"ab","name":"Abkhazian - AB","en_name":"Abkhazian - AB","original":"Abkhazian"},
    {"code":"ae","name":"Avestan - AE","en_name":"Avestan - AE","original":"Avestan"},
    {"code":"af","name":"아프리칸스어 - AF","en_name":"Afrikaans - AF","original":"Afrikaans"},
    {"code":"ak","name":"Akan - AK","en_name":"Akan - AK","original":"Akan"},
    {"code":"am","name":"Amharic - AM","en_name":"Amharic - AM","original":"Amharic"},
    {"code":"an","name":"Aragonese - AN","en_name":"Aragonese - AN","original":"Aragonese"},
    {"code":"as","name":"Assamese - AS","en_name":"Assamese - AS","original":"Assamese"},
    {"code":"av","name":"Avaric - AV","en_name":"Avaric - AV","original":"Avaric"},
    {"code":"ay","name":"Aymara - AY","en_name":"Aymara - AY","original":"Aymara"},
    {"code":"az","name":"아제르바이잔어 - AZ","en_name":"Azerbaijani - AZ","original":"Azerbaijani"},
    {"code":"ba","name":"바슈키르어 - BA","en_name":"Bashkir - BA","original":"Bashkir"},
    {"code":"be","name":"벨라루스어 - BE","en_name":"Belarusian - BE","original":"Belarusian"},
    {"code":"bh","name":"비하리어 - BH","en_name":"Bihari - BH","original":"Bihari "},
    {"code":"bi","name":"비슐라마 - BI","en_name":"Bislama - BI","original":"Bislama"},
    {"code":"bm","name":"밤바라어 - BM","en_name":"Bambara - BM","original":"Bambara"},
    {"code":"bo","name":"티베트어 - BO","en_name":"Tibetan - BO","original":"Tibetan"},
    {"code":"br","name":"브레통어 - BR","en_name":"Breton - BR","original":"Breton"},
    {"code":"bs","name":"보스니아어 - BS","en_name":"Bosnian - BS","original":"Bosnian"},
    {"code":"ca","name":"카탈루냐어 - CA","en_name":"Catalan - CA","original":"Catalan; Valencian"},
    {"code":"ce","name":"체첸어 - CE","en_name":"Chechen - CE","original":"Chechen"},
    {"code":"ch","name":"차모로어 - CH","en_name":"Chamorro - CH","original":"Chamorro"},
    {"code":"co","name":"코르시카어 - CO","en_name":"Corsican - CO","original":"Corsican"},
    {"code":"cr","name":"크리어 - CR","en_name":"Cree - CR","original":"Cree"},
    {"code":"cu","name":"Old Church Slavonic - CU","en_name":"Old Church Slavonic - CU","original":"Old Church Slavonic"},
    {"code":"cv","name":"Chuvash - CV","en_name":"Chuvash - CV","original":"Chuvash"},
    {"code":"cy","name":"Welsh - CY","en_name":"Welsh - CY","original":"Welsh"},
    {"code":"dv","name":"디베히어 - DV","en_name":"Dhivehi - DV","original":"Dhivehi; Maldivian"},
    {"code":"dz","name":"Dzongkha - DZ","en_name":"Dzongkha - DZ","original":"Dzongkha"},
    {"code":"ee","name":"Ewe - EE","en_name":"Ewe - EE","original":"Ewe"},
    {"code":"eo","name":"에스페란토 - EO","en_name":"Esperanto - EO","original":"Esperanto"},
    {"code":"eu","name":"바스크어 - EU","en_name":"Basque - EU","original":"Basque"},
    {"code":"fa","name":"페르시아어(이란) - FA","en_name":"Persian - FA","original":"Persian"},
    {"code":"ff","name":"풀라어 - FF","en_name":"Fulah - FF","original":"Fulah"},
    {"code":"fj","name":"피지어 - FJ","en_name":"Fijian - FJ","original":"Fijian"},
    {"code":"fo","name":"페로어 - FO","en_name":"Faroese - FO","original":"Faroese"},
    {"code":"fy","name":"프리지아어 - FY","en_name":"Western Frisian - FY","original":"Western Frisian"},
    {"code":"gd","name":"게일어 - GD","en_name":"Gaelic - GD","original":"Gaelic; Scottish Gaelic"},
    {"code":"gl","name":"갈리시아어 - GL","en_name":"Galician - GL","original":"Galician"},
    {"code":"gn","name":"과라니어 - GN","en_name":"Guarani - GN","original":"Guarani"},
    {"code":"gu","name":"구자라티어 - GU","en_name":"Gujarati - GU","original":"Gujarati"},
    {"code":"gv","name":"맨어 (맹크스) - GV","en_name":"Manx - GV","original":"Manx"},
    {"code":"ha","name":"하우사어 - HA","en_name":"Hausa - HA","original":"Hausa"},
    {"code":"ho","name":"Hiri Motu - HO","en_name":"Hiri Motu - HO","original":"Hiri Motu"},
    {"code":"ht","name":"아이티크리올어 - HT","en_name":"Haitian - HT","original":"Haitian; Haitian Creole"},
    {"code":"hy","name":"아르메니아어 - HY","en_name":"Armenian - HY","original":"Armenian"},
    {"code":"hz","name":"헤레로어 - HZ","en_name":"Herero - HZ","original":"Herero"},
    {"code":"ia","name":"인터링구아 - IA","en_name":"Interlingua - IA","original":"Interlingua"},
    {"code":"ie","name":"Interlingue; Occidental - IE","en_name":"Interlingue; Occidental - IE","original":"Interlingue; Occidental"},
    {"code":"ig","name":"Igbo - IG","en_name":"Igbo - IG","original":"Igbo"},
    {"code":"ii","name":"이어 (쓰촨에서 사용) - II","en_name":"Sichuan Yi - II","original":"Sichuan Yi; Nuosu"},
    {"code":"ik","name":"이누피아크어 - IK","en_name":"Inupiaq - IK","original":"Inupiaq"},
    {"code":"io","name":"이도 - IO","en_name":"Ido - IO","original":"Ido"},
    {"code":"is","name":"아이슬란드어 - IS","en_name":"Icelandic - IS","original":"Icelandic"},
    {"code":"iu","name":"이누이트어 - IU","en_name":"Inuktitut - IU","original":"Inuktitut"},
    {"code":"jv","name":"자바어 - JV","en_name":"Javanese - JV","original":"Javanese"},
    {"code":"ka","name":"그루지야어 - KA","en_name":"Georgian - KA","original":"Georgian"},
    {"code":"kg","name":"콩고어 - KG","en_name":"Kongo - KG","original":"Kongo"},
    {"code":"ki","name":"키쿠유어 - KI","en_name":"Kikuyu - KI","original":"Kikuyu; Gikuyu"},
    {"code":"kj","name":"콰냐마어 - KJ","en_name":"Kuanyama - KJ","original":"Kuanyama; Kwanyama"},
    {"code":"kk","name":"카자흐어 - KK","en_name":"Kazakh - KK","original":"Kazakh"},
    {"code":"kl","name":"그린란드어 - KL","en_name":"Greenlandic - KL","original":"Kalaallisut; Greenlandic"},
    {"code":"km","name":"크메르어 - KM","en_name":"Central Khmer - KM","original":"Central Khmer"},
    {"code":"kn","name":"칸나다어 - KN","en_name":"Kannada - KN","original":"Kannada"},
    {"code":"kr","name":"카누리어 - KR","en_name":"Kanuri - KR","original":"Kanuri"},
    {"code":"ks","name":"카슈미르어 - KS","en_name":"Kashmiri - KS","original":"Kashmiri"},
    {"code":"ku","name":"쿠르드어 - KU","en_name":"Kurdish - KU","original":"Kurdish"},
    {"code":"kv","name":"페름어 (코미어) - KV","en_name":"Komi - KV","original":"Komi"},
    {"code":"kw","name":"Cornish - KW","en_name":"Cornish - KW","original":"Cornish"},
    {"code":"ky","name":"키르기스어 - KY","en_name":"Kirghiz - KY","original":"Kirghiz; Kyrgyz"},
    {"code":"la","name":"라틴어 - LA","en_name":"Latin - LA","original":"Latin"},
    {"code":"lb","name":"룩셈부르크어 - LB","en_name":"Luxembourgish - LB","original":"Letzeburgesch"},
    {"code":"lg","name":"간다어 - LG","en_name":"Ganda - LG","original":"Ganda"},
    {"code":"li","name":"림뷔르흐어 - LI","en_name":"Limburgish - LI","original":"Limburgish"},
    {"code":"ln","name":"링갈라어 - LN","en_name":"Lingala - LN","original":"Lingala"},
    {"code":"lo","name":"라오어 - LO","en_name":"Lao - LO","original":"Lao"},
    {"code":"lu","name":"루바-카탕가어 - LU","en_name":"Luba-Katanga - LU","original":"Luba-Katanga"},
    {"code":"mg","name":"마다가스카르어 - MG","en_name":"Malagasy - MG","original":"Malagasy"},
    {"code":"mh","name":"Marshallese - MH","en_name":"Marshallese - MH","original":"Marshallese"},
    {"code":"mi","name":"마오리어 - MI","en_name":"Maori - MI","original":"Maori"},
    {"code":"mk","name":"마케도니아어 - MK","en_name":"Macedonian - MK","original":"Macedonian"},
    {"code":"ml","name":"말라얄람어 - ML","en_name":"Malayalam - ML","original":"Malayalam"},
    {"code":"mn","name":"몽골어 - MN","en_name":"Mongolian - MN","original":"Mongolian"},
    {"code":"ms","name":"말레이어 - MS","en_name":"Malay - MS","original":"Malay"},
    {"code":"mt","name":"몰타어 - MT","en_name":"Maltese - MT","original":"Maltese"},
    {"code":"my","name":"Burmese - MY","en_name":"Burmese - MY","original":"Burmese"},
    {"code":"na","name":"나우루어 - NA","en_name":"Nauru - NA","original":"Nauru"},
    {"code":"nb","name":"Norwegian Bokmål - NB","en_name":"Norwegian Bokmål - NB","original":"Norwegian Bokmål"},
    {"code":"nd","name":"North Ndebele - ND","en_name":"North Ndebele - ND","original":"North Ndebele"},
    {"code":"ne","name":"네팔어 - NE","en_name":"Nepali - NE","original":"Nepali"},
    {"code":"ng","name":"Ndonga - NG","en_name":"Ndonga - NG","original":"Ndonga"},
    {"code":"nn","name":"Norwegian Nynorsk - NN","en_name":"Norwegian Nynorsk - NN","original":"Norwegian Nynorsk"},
    {"code":"nr","name":"South Ndebele - NR","en_name":"South Ndebele - NR","original":"South Ndebele"},
    {"code":"nv","name":"나바호어 - NV","en_name":"Navajo - NV","original":"Navajo; Navaho"},
    {"code":"ny","name":"Chichewa - NY","en_name":"Chichewa - NY","original":"Chichewa; Chewa; Nyanja"},
    {"code":"oc","name":"프로방스어(남부 프랑스) - OC","en_name":"Occitan - OC","original":"Occitan (post 1500)"},
    {"code":"oj","name":"오지브와어 - OJ","en_name":"Ojibwa - OJ","original":"Ojibwa"},
    {"code":"om","name":"갈라어 (오로모어) - OM","en_name":"Oromo - OM","original":"Oromo"},
    {"code":"or","name":"오리야어 - OR","en_name":"Oriya - OR","original":"Oriya"},
    {"code":"os","name":"오세트어 - OS","en_name":"Ossetian - OS","original":"Ossetian; Ossetic"},
    {"code":"pa","name":"펀자브어 - PA","en_name":"Panjabi - PA","original":"Panjabi; Punjabi"},
    {"code":"pi","name":"팔리어 - PI","en_name":"Pali - PI","original":"Pali"},
    {"code":"ps","name":"파슈툰어 - PS","en_name":"Pushto; Pashto - PS","original":"Pushto; Pashto"},
    {"code":"qu","name":"케추아어 - QU","en_name":"Quechua - QU","original":"Quechua"},
    {"code":"rm","name":"레토-로만어 - RM","en_name":"Romansh - RM","original":"Romansh"},
    {"code":"rn","name":"룬디어 - RN","en_name":"Rundi - RN","original":"Rundi"},
    {"code":"rw","name":"르완다어 - RW","en_name":"Kinyarwanda - RW","original":"Kinyarwanda"},
    {"code":"sa","name":"산스크리트(범어) - SA","en_name":"Sanskrit - SA","original":"Sanskrit"},
    {"code":"sc","name":"사르데냐어 - SC","en_name":"Sardinian - SC","original":"Sardinian"},
    {"code":"sd","name":"신드어 - SD","en_name":"Sindhi - SD","original":"Sindhi"},
    {"code":"se","name":"북사미어 - SE","en_name":"Northern Sami - SE","original":"Northern Sami"},
    {"code":"sg","name":"Sango - SG","en_name":"Sango - SG","original":"Sango"},
    {"code":"si","name":"싱할라어 - SI","en_name":"Sinhala - SI","original":"Sinhala; Sinhalese"},
    {"code":"sm","name":"사모아어 - SM","en_name":"Samoan - SM","original":"Samoan"},
    {"code":"sn","name":"쇼나어 - SN","en_name":"Shona - SN","original":"Shona"},
    {"code":"so","name":"소말리어 - SO","en_name":"Somali - SO","original":"Somali"},
    {"code":"sq","name":"알바니아어 - SQ","en_name":"Albanian - SQ","original":"Albanian"},
    {"code":"ss","name":"스와티어 - SS","en_name":"Swati - SS","original":"Swati"},
    {"code":"st","name":"남소토어 - ST","en_name":"Sotho,Southern - ST","original":"Sotho,Southern"},
    {"code":"su","name":"순다어 - SU","en_name":"Sundanese - SU","original":"Sundanese"},
    {"code":"sw","name":"스와힐리어 - SW","en_name":"Swahili - SW","original":"Swahili"},
    {"code":"tg","name":"타지크어 - TG","en_name":"Tajik - TG","original":"Tajik"},
    {"code":"ti","name":"티그리냐어 - TI","en_name":"Tigrinya - TI","original":"Tigrinya"},
    {"code":"tk","name":"투르크멘어 - TK","en_name":"Turkmen - TK","original":"Turkmen"},
    {"code":"tl","name":"타갈로그 - TL","en_name":"Tagalog - TL","original":"Tagalog"},
    {"code":"tn","name":"츠와나어 - TN","en_name":"Tswana - TN","original":"Tswana"},
    {"code":"to","name":"통가어 - TO","en_name":"Tonga - TO","original":"Tonga"},
    {"code":"ts","name":"총가어 - TS","en_name":"Tsonga - TS","original":"Tsonga"},
    {"code":"tt","name":"타타르어 - TT","en_name":"Tatar - TT","original":"Tatar"},
    {"code":"tw","name":"트위어 - TW","en_name":"Twi - TW","original":"Twi"},
    {"code":"ty","name":"타이티어 - TY","en_name":"Tahitian - TY","original":"Tahitian"},
    {"code":"ug","name":"위구르어 - UG","en_name":"Uighur - UG","original":"Uighur; Uyghur"},
    {"code":"uz","name":"우즈베크어 - UZ","en_name":"Uzbek - UZ","original":"Uzbek"},
    {"code":"ve","name":"벤다어 - VE","en_name":"Venda - VE","original":"Venda"},
    {"code":"vo","name":"볼라퓌크 - VO","en_name":"Volapük - VO","original":"Volapük"},
    {"code":"wa","name":"왈론어 - WA","en_name":"Walloon - WA","original":"Walloon"},
    {"code":"wo","name":"월로프어 - WO","en_name":"Wolof - WO","original":"Wolof"},
    {"code":"xh","name":"코사어 - XH","en_name":"Xhosa - XH","original":"Xhosa"},
    {"code":"yi","name":"이디시어 - YI","en_name":"Yiddish - YI","original":"Yiddish"},
    {"code":"yo","name":"요루바어 - YO","en_name":"Yoruba - YO","original":"Yoruba"},
    {"code":"za","name":"Zhuang - ZA","en_name":"Zhuang - ZA","original":"Zhuang; Chuang"},
    {"code":"zu","name":"Zulu - ZU","en_name":"Zulu - ZU","original":"Zulu"}]
)


// 은행
const bank = [
    {name: "국민은행", code: "004"},
    {name: "신한은행", code: "088"},
    {name: "우리은행", code: "020"},
    {name: "농협은행", code: "011"},
    {name: "카카오뱅크", code: "090"},
    {name: "KEB하나은행", code: "081"},
    {name: "기업은행", code: "003"},
    {name: "SC제일은행", code: "023"},
    {name: "새마을금고중앙회", code: "045"},
    {name: "우체국", code: "071"},
    {name: "부산은행", code: "032"},
    {name: "대구은행", code: "031"},
    {name: "한국씨티은행", code: "027"},
    {name: "광주은행", code: "034"},
    {name: "경남은행", code: "039"},
    {name: "신협", code: "048"},
    {name: "케이뱅크", code: "089"},
    {name: "토스뱅크", code: "092"},


    {name: "하나금융투자", code: "270"},
    {name: "유안타증권", code: "209"},
    {name: "도이치은행", code: "055"},
    {name: "산업은행", code: "002"},
    {name: "저축은행", code: "050"},
    {name: "수협은행", code: "007"},
    {name: "전북은행", code: "037"},
    {name: "제주은행", code: "035"},
    {name: "BOA", code: "060"},
    {name: "HSBC", code: "054"},
    {name: "제이피모건체이스은행", code: "057"},
    {name: "산림조합중앙회", code: "064"},
    {name: "중국공상은행", code: "062"},
    {name: "중국은행", code: "063"},
    {name: "중국건설은행", code: "067"},
    {name: "비엔피파리바은행", code: "061"},
    {name: "교보증권", code: "261"},
    {name: "대신증권", code: "067"},
    {name: "미래에셋대우", code: "238"},
    {name: "DB금융투자", code: "279"},
    {name: "메리츠종합금융증권", code: "287"},
    {name: "부국증권", code: "290"},
    {name: "삼성증권", code: "240"},
    {name: "신영증권", code: "291"},
    {name: "신한금융투자", code: "278"},
    {name: "NH투자증권", code: "247"},
    {name: "유진투자증권", code: "280"},
    {name: "키움증권", code: "264"},
    {name: "하이투자증권", code: "262"},
    {name: "한국투자증권", code: "243"},
    {name: "한화투자증권", code: "269"},
    {name: "KB증권", code: "218"},
    {name: "이베스트투자증권", code: "265"},
    {name: "현대차투자증권", code: "263"},
    {name: "케이프투자증권", code: "292"},
    {name: "SK증권", code: "266"},
    {name: "한국포스증권", code: "294"},
    {name: "케이티비투자증권", code: "227"},
    {name: "BNK투자증권", code: "224"},
    {name: "바로투자증권", code: "288"},
]

const permissionOption = {
    default : {
        label : '기본 설정',
        list :['userView','userEdit','userDownload']
             
    }
}

const userObject = {
    bankaccount:{
        account_number: null,
        bank_branch: null,
        bank_name: null,
        bank_code : null,
        name: null,
        payment_method: null,
        address : {
            address_line: null,
            address_line2: null,
            city: null,
            district: null,
            postal_code: null,
        }
    },
    ddex_partyid : null, 
    company: null,
    currency: null,
    default_service_fee_kr: 50,
    default_service_fee_other: 50,
    entity: null,
    entity_address: {
        address_line: null, // 거주 주소
        address_line2: null, // 거주 주소
        country: null, // 거주 국가
        postal_code: null, // 거주 우편번호
    },
    entity_date: null,
    entity_identification: null,
    entity_identification_type: null,
    entity_tax_exemption: false,
    family_name: null,
    given_name: null,
    mims_account: null,
    nationality: null,
    phone: null,
    phone_countrycode: null,
}

// 유통 상태
const albumStatus = Object.freeze([
    { value: 'registration_complete', label: '접수' },
    { value: 'registration_canceled', label: '유통취소' },
    { value: 'inspection_complete', label: '검수완료' },
    { value: 'distribution_complete', label: '유통완료' },
    { value: 'suspended', label: '유통중단' },
    { value: 'rejected', label: '반려' },
    { value: 'release_complete', label: '발매완료' },
    { value: 'trash', label: '임시 삭제' },
    { value: 'temporary', label: '임시 저장' },
])
  
  // 앨범 신청 방법
const albumSource = Object.freeze([
    { value: 'direct', label: 'Direct' },
    { value: 'sftp', label: 'SFTP' },
    { value: 'sftp-bulk', label: 'SFTP-BULK' },
    { value: 'easyupload', label: 'Easy Upload' },
])

// 신청 구분
const copyrightType = Object.freeze([
    { value: 'new', label: '신규' },
    { value: 'transfer', label: '이관' },
])
  
// Youtube CID 관리사
const youtubeCID = Object.freeze([
    { value: 'none', label: '없음' },
    { value: 'soundrepublica', label: '사운드리퍼블리카' },
    { value: 'consalad', label: '콘샐러드' },
    { value: 're-1', label: '리원' },
    { value: 'soribada', label: '소리바다' },
])
  
// 트랙 유형
const trackType = Object.freeze([
    { value: 'original', label: 'Original' },
    { value: 'live', label: 'Live' },
    { value: 'instrumental', label: 'Instrumental' },
    { value: 'acoustic', label: 'Acoustic' },
    { value: 'acapella', label: 'Acapella' },
    { value: 'extended_version', label: 'Extended Version' },
    { value: 'radio_edit', label: 'Radio Edit' },
    { value: 'clean', label: 'Clean' },
    { value: 'cover', label: 'Cover' },
    { value: 'remastered', label: 'Remastered' },
    { value: 're_recorded', label: 'Re Recorded' },
    { value: 'remix', label: 'Remix' },
    { value: 'remake', label: 'Remake' },
    { value: 'soundtrack', label: 'Soundtrack' },
    { value: 'bonus_track', label: 'Bonus Track' },
    { value: 'hidden_track', label: 'Hidden Track' },
    { value: 'chorus_version', label: 'Chorus Version' },
    { value: 'etc', label: '직접입력' }, //직접입력 시 type =  null  , alt_type = value
])
// 앨범 형식
const releaseType = Object.freeze([
    { value: 'single', label: 'Single' },
    { value: 'ep', label: 'EP' },
    { value: 'album', label: 'Album' },
])
const artistType = Object.freeze([
    { value: 'solo_male', label: '남성 솔로' },
    { value: 'solo_female', label: '여성 솔로' },
    { value: 'group_male', label: '남성 그룹' },
    { value: 'group_female', label: '여성 그룹' },
    { value: 'group_combined', label: '혼성 그룹' },
])

const sns = Object.freeze([
    { value: 'youtube', label: 'Youtube' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'twitter', label: 'Twitter' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'website', label: 'Website' },
])

//‘composer’, ‘lyricist’, ‘arranger’, ‘producer’, ‘remixer’, ‘conductor’, choir, orchestra, translator, narrator, studio_musician, studio_personnel
const contributors = Object.freeze([
    { value: 'composer', label: '작곡가' },
    { value: 'lyricist', label: '작사가' },
    { value: 'arranger', label: '편곡가' },
    { value: 'producer', label: '프로듀서' },
    { value: 'publisher', label: 'Publisher' },
    { value: 'remixer', label: 'Remixer' },
    { value: 'conductor', label: 'Conductor' },
    { value: 'choir', label: 'Choir' },
    { value: 'orchestra', label: 'Orchestra' },
    { value: 'translator', label: 'Translator' },
    { value: 'narrator', label: 'Narrator' },
    { value: 'studio_musician', label: 'Studio Musician' },
    { value: 'cello', label: 'Cello' },
    { value: 'piano', label: 'Piano' },
    { value: 'violin', label: 'Violin' },
    { value: 'vocal', label: 'Vocal' },
    { value: 'organ', label: 'Organ' },
    { value: 'soprano', label: 'Soprano' },
    { value: 'bass', label: 'Bass' },
    { value: 'tenor', label: 'Tenor' },
 
])
const boolean = Object.freeze([
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
])
const withrawalState = Object.freeze([
    {value : 'requested', label : '출금신청',},
    {value : 'fulfilled', label : '지급완료',},
    {value : 'rejected', label : '반려완료',},
])

const adminList  = [
    {label : '담당자 없음',value : null},
    {label : 'Brian',value : 'Brian'},
    {label : 'Leonie',value : 'Leonie'},
    {label : 'Chaey',value : 'Chaey'},
    {label : 'Celine',value : 'Celine'},
    {label : 'Michaella',value : 'Michaella'},
    {label : 'Terrence',value : 'Terrence'},
    {label : 'Marty',value : 'Marty'},
]
const timezone = [{"value":"KST","time-utc":"UTC+09:00","time":"+09:00","label":"KST(Seoul) (UTC+09:00)"},
{"value":"EST","time-utc":"UTC−05:00","time":"−05:00","label":"EST(New York) (UTC−05:00)"},
{"value":"PST","time-utc":"UTC−08:00","time":"−08:00","label":"PST(LA) (UTC−08:00)"},
{"value":"BST+1","time-utc":"UTC+01:00","time":"+01:00","label":"BST(London) (UTC+01:00)"},
{"value":"CST+8","time-utc":"UTC+08:00","time":"+08:00","label":"CST(China) (UTC+08:00)"},
{"value":"IST+1","time-utc":"UTC+01:00","time":"+01:00","label":"IST(Irish) (UTC+01:00)"},
{"value":"CET","time-utc":"UTC+01:00","time":"+01:00","label":"CET (UTC+01:00)"},
{"value":"DFT","time-utc":"UTC+01:00","time":"+01:00","label":"DFT (UTC+01:00)"},
{"value":"WAT","time-utc":"UTC+01:00","time":"+01:00","label":"WAT (UTC+01:00)"},
{"value":"WEST","time-utc":"UTC+01:00","time":"+01:00","label":"WEST (UTC+01:00)"},
{"value":"IST+2","time-utc":"UTC+02:00","time":"+02:00","label":"IST(Israel) (UTC+02:00)"},
{"value":"CAT","time-utc":"UTC+02:00","time":"+02:00","label":"CAT (UTC+02:00)"},
{"value":"CEST","time-utc":"UTC+02:00","time":"+02:00","label":"CEST (UTC+02:00)"},
{"value":"EET","time-utc":"UTC+02:00","time":"+02:00","label":"EET (UTC+02:00)"},
{"value":"HAEC","time-utc":"UTC+02:00","time":"+02:00","label":"HAEC (UTC+02:00)"},
{"value":"KALT","time-utc":"UTC+02:00","time":"+02:00","label":"KALT (UTC+02:00)"},
{"value":"MEST","time-utc":"UTC+02:00","time":"+02:00","label":"MEST (UTC+02:00)"},
{"value":"SAST","time-utc":"UTC+02:00","time":"+02:00","label":"SAST (UTC+02:00)"},
{"value":"WAST","time-utc":"UTC+02:00","time":"+02:00","label":"WAST (UTC+02:00)"},
{"value":"AST+3","time-utc":"UTC+03:00","time":"+03:00","label":"AST(Arabia) (UTC+03:00)"},
{"value":"EAT","time-utc":"UTC+03:00","time":"+03:00","label":"EAT (UTC+03:00)"},
{"value":"EEST","time-utc":"UTC+03:00","time":"+03:00","label":"EEST (UTC+03:00)"},
{"value":"FET","time-utc":"UTC+03:00","time":"+03:00","label":"FET (UTC+03:00)"},
{"value":"IDT","time-utc":"UTC+03:00","time":"+03:00","label":"IDT (UTC+03:00)"},
{"value":"IOT","time-utc":"UTC+03:00","time":"+03:00","label":"IOT (UTC+03:00)"},
{"value":"MSK","time-utc":"UTC+03:00","time":"+03:00","label":"MSK (UTC+03:00)"},
{"value":"SYOT","time-utc":"UTC+03:00","time":"+03:00","label":"SYOT (UTC+03:00)"},
{"value":"TRT","time-utc":"UTC+03:00","time":"+03:00","label":"TRT (UTC+03:00)"},
{"value":"IRST","time-utc":"UTC+03:30","time":"+03:30","label":"IRST (UTC+03:30)"},
{"value":"GST+4","time-utc":"UTC+04:00","time":"+04:00","label":"GST(Gulf) (UTC+04:00)"},
{"value":"AMT+04","time-utc":"UTC+04:00","time":"+04:00","label":"AMT(Armenia) (UTC+04:00)"},
{"value":"AZT","time-utc":"UTC+04:00","time":"+04:00","label":"AZT (UTC+04:00)"},
{"value":"GET","time-utc":"UTC+04:00","time":"+04:00","label":"GET (UTC+04:00)"},
{"value":"MUT","time-utc":"UTC+04:00","time":"+04:00","label":"MUT (UTC+04:00)"},
{"value":"RET","time-utc":"UTC+04:00","time":"+04:00","label":"RET (UTC+04:00)"},
{"value":"SAMT","time-utc":"UTC+04:00","time":"+04:00","label":"SAMT (UTC+04:00)"},
{"value":"SCT","time-utc":"UTC+04:00","time":"+04:00","label":"SCT (UTC+04:00)"},
{"value":"VOLT","time-utc":"UTC+04:00","time":"+04:00","label":"VOLT (UTC+04:00)"},
{"value":"AFT","time-utc":"UTC+04:30","time":"+04:30","label":"AFT (UTC+04:30)"},
{"value":"IRDT","time-utc":"UTC+04:30","time":"+04:30","label":"IRDT (UTC+04:30)"},
{"value":"AQTT","time-utc":"UTC+05:00","time":"+05:00","label":"AQTT (UTC+05:00)"},
{"value":"HMT","time-utc":"UTC+05:00","time":"+05:00","label":"HMT (UTC+05:00)"},
{"value":"MAWT","time-utc":"UTC+05:00","time":"+05:00","label":"MAWT (UTC+05:00)"},
{"value":"MVT","time-utc":"UTC+05:00","time":"+05:00","label":"MVT (UTC+05:00)"},
{"value":"ORAT","time-utc":"UTC+05:00","time":"+05:00","label":"ORAT (UTC+05:00)"},
{"value":"PKT","time-utc":"UTC+05:00","time":"+05:00","label":"PKT (UTC+05:00)"},
{"value":"TFT","time-utc":"UTC+05:00","time":"+05:00","label":"TFT (UTC+05:00)"},
{"value":"TJT","time-utc":"UTC+05:00","time":"+05:00","label":"TJT (UTC+05:00)"},
{"value":"TMT","time-utc":"UTC+05:00","time":"+05:00","label":"TMT (UTC+05:00)"},
{"value":"UZT","time-utc":"UTC+05:00","time":"+05:00","label":"UZT (UTC+05:00)"},
{"value":"YEKT","time-utc":"UTC+05:00","time":"+05:00","label":"YEKT (UTC+05:00)"},
{"value":"IST+5","time-utc":"UTC+05:30","time":"+05:30","label":"IST(Indian) (UTC+05:30)"},
{"value":"SLST","time-utc":"UTC+05:30","time":"+05:30","label":"SLST (UTC+05:30)"},
{"value":"NPT","time-utc":"UTC+05:45","time":"+05:45","label":"NPT (UTC+05:45)"},
{"value":"BST+6","time-utc":"UTC+06:00","time":"+06:00","label":"BST(Bangaldesh) (UTC+06:00)"},
{"value":"ALMT","time-utc":"UTC+06:00","time":"+06:00","label":"ALMT (UTC+06:00)"},
{"value":"BIOT","time-utc":"UTC+06:00","time":"+06:00","label":"BIOT (UTC+06:00)"},
{"value":"BTT","time-utc":"UTC+06:00","time":"+06:00","label":"BTT (UTC+06:00)"},
{"value":"KGT","time-utc":"UTC+06:00","time":"+06:00","label":"KGT (UTC+06:00)"},
{"value":"OMST","time-utc":"UTC+06:00","time":"+06:00","label":"OMST (UTC+06:00)"},
{"value":"VOST","time-utc":"UTC+06:00","time":"+06:00","label":"VOST (UTC+06:00)"},
{"value":"CCT","time-utc":"UTC+06:30","time":"+06:30","label":"CCT (UTC+06:30)"},
{"value":"MMT","time-utc":"UTC+06:30","time":"+06:30","label":"MMT (UTC+06:30)"},
{"value":"CXT","time-utc":"UTC+07:00","time":"+07:00","label":"CXT (UTC+07:00)"},
{"value":"DAVT","time-utc":"UTC+07:00","time":"+07:00","label":"DAVT (UTC+07:00)"},
{"value":"HOVT","time-utc":"UTC+07:00","time":"+07:00","label":"HOVT (UTC+07:00)"},
{"value":"ICT","time-utc":"UTC+07:00","time":"+07:00","label":"ICT (UTC+07:00)"},
{"value":"KRAT","time-utc":"UTC+07:00","time":"+07:00","label":"KRAT (UTC+07:00)"},
{"value":"NOVT","time-utc":"UTC+07:00","time":"+07:00","label":"NOVT (UTC+07:00)"},
{"value":"THA","time-utc":"UTC+07:00","time":"+07:00","label":"THA (UTC+07:00)"},
{"value":"WIB","time-utc":"UTC+07:00","time":"+07:00","label":"WIB (UTC+07:00)"},
{"value":"ACT+8","time-utc":"UTC+08:00","time":"+08:00","label":"ACT(ASEAN) (UTC+08:00)"},
{"value":"MST+8","time-utc":"UTC+08:00","time":"+08:00","label":"MST(Malaysia) (UTC+08:00)"},
{"value":"SST+8","time-utc":"UTC+08:00","time":"+08:00","label":"SST(Singapore) (UTC+08:00)"},
{"value":"AWST","time-utc":"UTC+08:00","time":"+08:00","label":"AWST (UTC+08:00)"},
{"value":"BNT","time-utc":"UTC+08:00","time":"+08:00","label":"BNT (UTC+08:00)"},
{"value":"CHOT","time-utc":"UTC+08:00","time":"+08:00","label":"CHOT (UTC+08:00)"},
{"value":"HKT","time-utc":"UTC+08:00","time":"+08:00","label":"HKT (UTC+08:00)"},
{"value":"HOVST","time-utc":"UTC+08:00","time":"+08:00","label":"HOVST (UTC+08:00)"},
{"value":"IRKT","time-utc":"UTC+08:00","time":"+08:00","label":"IRKT (UTC+08:00)"},
{"value":"MYT","time-utc":"UTC+08:00","time":"+08:00","label":"MYT (UTC+08:00)"},
{"value":"PHST","time-utc":"UTC+08:00","time":"+08:00","label":"PHST (UTC+08:00)"},
{"value":"PHT","time-utc":"UTC+08:00","time":"+08:00","label":"PHT (UTC+08:00)"},
{"value":"SGT","time-utc":"UTC+08:00","time":"+08:00","label":"SGT (UTC+08:00)"},
{"value":"ULAT","time-utc":"UTC+08:00","time":"+08:00","label":"ULAT (UTC+08:00)"},
{"value":"WITA","time-utc":"UTC+08:00","time":"+08:00","label":"WITA (UTC+08:00)"},
{"value":"WST","time-utc":"UTC+08:00","time":"+08:00","label":"WST (UTC+08:00)"},
{"value":"ACWST","time-utc":"UTC+08:45","time":"+08:45","label":"ACWST (UTC+08:45)"},
{"value":"CWST","time-utc":"UTC+08:45","time":"+08:45","label":"CWST (UTC+08:45)"},
{"value":"CHOST","time-utc":"UTC+09:00","time":"+09:00","label":"CHOST (UTC+09:00)"},
{"value":"JST","time-utc":"UTC+09:00","time":"+09:00","label":"JST (UTC+09:00)"},
{"value":"PWT","time-utc":"UTC+09:00","time":"+09:00","label":"PWT (UTC+09:00)"},
{"value":"TLT","time-utc":"UTC+09:00","time":"+09:00","label":"TLT (UTC+09:00)"},
{"value":"ULAST","time-utc":"UTC+09:00","time":"+09:00","label":"ULAST (UTC+09:00)"},
{"value":"WIT","time-utc":"UTC+09:00","time":"+09:00","label":"WIT (UTC+09:00)"},
{"value":"YAKT","time-utc":"UTC+09:00","time":"+09:00","label":"YAKT (UTC+09:00)"},
{"value":"ACST","time-utc":"UTC+09:30","time":"+09:30","label":"ACST (UTC+09:30)"},
{"value":"AEST","time-utc":"UTC+10:00","time":"+10:00","label":"AEST (UTC+10:00)"},
{"value":"CHST","time-utc":"UTC+10:00","time":"+10:00","label":"CHST (UTC+10:00)"},
{"value":"CHUT","time-utc":"UTC+10:00","time":"+10:00","label":"CHUT (UTC+10:00)"},
{"value":"DDUT","time-utc":"UTC+10:00","time":"+10:00","label":"DDUT (UTC+10:00)"},
{"value":"PGT","time-utc":"UTC+10:00","time":"+10:00","label":"PGT (UTC+10:00)"},
{"value":"VLAT","time-utc":"UTC+10:00","time":"+10:00","label":"VLAT (UTC+10:00)"},
{"value":"LHST+10","time-utc":"UTC+10:30","time":"+10:30","label":"LHST(Standard) (UTC+10:30)"},
{"value":"ACDT","time-utc":"UTC+10:30","time":"+10:30","label":"ACDT (UTC+10:30)"},
{"value":"BST+11","time-utc":"UTC+11:00","time":"+11:00","label":"BST(Bougainville) (UTC+11:00)"},
{"value":"LHST+11","time-utc":"UTC+11:00","time":"+11:00","label":"LHST(Summer) (UTC+11:00)"},
{"value":"AEDT","time-utc":"UTC+11:00","time":"+11:00","label":"AEDT (UTC+11:00)"},
{"value":"KOST","time-utc":"UTC+11:00","time":"+11:00","label":"KOST (UTC+11:00)"},
{"value":"MIST","time-utc":"UTC+11:00","time":"+11:00","label":"MIST (UTC+11:00)"},
{"value":"NCT","time-utc":"UTC+11:00","time":"+11:00","label":"NCT (UTC+11:00)"},
{"value":"NFT","time-utc":"UTC+11:00","time":"+11:00","label":"NFT (UTC+11:00)"},
{"value":"PONT","time-utc":"UTC+11:00","time":"+11:00","label":"PONT (UTC+11:00)"},
{"value":"SAKT","time-utc":"UTC+11:00","time":"+11:00","label":"SAKT (UTC+11:00)"},
{"value":"SBT","time-utc":"UTC+11:00","time":"+11:00","label":"SBT (UTC+11:00)"},
{"value":"SRET","time-utc":"UTC+11:00","time":"+11:00","label":"SRET (UTC+11:00)"},
{"value":"VUT","time-utc":"UTC+11:00","time":"+11:00","label":"VUT (UTC+11:00)"},
{"value":"ANAT","time-utc":"UTC+12:00","time":"+12:00","label":"ANAT (UTC+12:00)"},
{"value":"FJT","time-utc":"UTC+12:00","time":"+12:00","label":"FJT (UTC+12:00)"},
{"value":"GILT","time-utc":"UTC+12:00","time":"+12:00","label":"GILT (UTC+12:00)"},
{"value":"MAGT","time-utc":"UTC+12:00","time":"+12:00","label":"MAGT (UTC+12:00)"},
{"value":"MHT","time-utc":"UTC+12:00","time":"+12:00","label":"MHT (UTC+12:00)"},
{"value":"NZST","time-utc":"UTC+12:00","time":"+12:00","label":"NZST (UTC+12:00)"},
{"value":"PETT","time-utc":"UTC+12:00","time":"+12:00","label":"PETT (UTC+12:00)"},
{"value":"TVT","time-utc":"UTC+12:00","time":"+12:00","label":"TVT (UTC+12:00)"},
{"value":"WAKT","time-utc":"UTC+12:00","time":"+12:00","label":"WAKT (UTC+12:00)"},
{"value":"CHAST","time-utc":"UTC+12:45","time":"+12:45","label":"CHAST (UTC+12:45)"},
{"value":"NZDT","time-utc":"UTC+13:00","time":"+13:00","label":"NZDT (UTC+13:00)"},
{"value":"PHOT","time-utc":"UTC+13:00","time":"+13:00","label":"PHOT (UTC+13:00)"},
{"value":"TKT","time-utc":"UTC+13:00","time":"+13:00","label":"TKT (UTC+13:00)"},
{"value":"TOT","time-utc":"UTC+13:00","time":"+13:00","label":"TOT (UTC+13:00)"},
{"value":"CHADT","time-utc":"UTC+13:45","time":"+13:45","label":"CHADT (UTC+13:45)"},
{"value":"LINT","time-utc":"UTC+14:00","time":"+14:00","label":"LINT (UTC+14:00)"},
{"value":"AZOST","time-utc":"UTC±00:00","time":"±00:00","label":"AZOST (UTC±00:00)"},
{"value":"EGST","time-utc":"UTC±00:00","time":"±00:00","label":"EGST (UTC±00:00)"},
{"value":"GMT","time-utc":"UTC±00:00","time":"±00:00","label":"GMT (UTC±00:00)"},
{"value":"UTC","time-utc":"UTC±00:00","time":"±00:00","label":"UTC (UTC±00:00)"},
{"value":"WET","time-utc":"UTC±00:00","time":"±00:00","label":"WET (UTC±00:00)"},
{"value":"AZOT","time-utc":"UTC−01:00","time":"−01:00","label":"AZOT (UTC−01:00)"},
{"value":"CVT","time-utc":"UTC−01:00","time":"−01:00","label":"CVT (UTC−01:00)"},
{"value":"EGT","time-utc":"UTC−01:00","time":"−01:00","label":"EGT (UTC−01:00)"},
{"value":"GST-2","time-utc":"UTC−02:00","time":"−02:00","label":"GST(South Georgia) (UTC−02:00)"},
{"value":"BRST","time-utc":"UTC−02:00","time":"−02:00","label":"BRST (UTC−02:00)"},
{"value":"FNT","time-utc":"UTC−02:00","time":"−02:00","label":"FNT (UTC−02:00)"},
{"value":"PMDT","time-utc":"UTC−02:00","time":"−02:00","label":"PMDT (UTC−02:00)"},
{"value":"UYST","time-utc":"UTC−02:00","time":"−02:00","label":"UYST (UTC−02:00)"},
{"value":"WGST","time-utc":"UTC−02:00","time":"−02:00","label":"WGST (UTC−02:00)"},
{"value":"NDT","time-utc":"UTC−02:30","time":"−02:30","label":"NDT (UTC−02:30)"},
{"value":"ADT","time-utc":"UTC−03:00","time":"−03:00","label":"ADT (UTC−03:00)"},
{"value":"AMST","time-utc":"UTC−03:00","time":"−03:00","label":"AMST (UTC−03:00)"},
{"value":"ART","time-utc":"UTC−03:00","time":"−03:00","label":"ART (UTC−03:00)"},
{"value":"BRT","time-utc":"UTC−03:00","time":"−03:00","label":"BRT (UTC−03:00)"},
{"value":"CLST","time-utc":"UTC−03:00","time":"−03:00","label":"CLST (UTC−03:00)"},
{"value":"FKST","time-utc":"UTC−03:00","time":"−03:00","label":"FKST (UTC−03:00)"},
{"value":"GFT","time-utc":"UTC−03:00","time":"−03:00","label":"GFT (UTC−03:00)"},
{"value":"PMST","time-utc":"UTC−03:00","time":"−03:00","label":"PMST (UTC−03:00)"},
{"value":"PYST","time-utc":"UTC−03:00","time":"−03:00","label":"PYST (UTC−03:00)"},
{"value":"ROTT","time-utc":"UTC−03:00","time":"−03:00","label":"ROTT (UTC−03:00)"},
{"value":"SRT","time-utc":"UTC−03:00","time":"−03:00","label":"SRT (UTC−03:00)"},
{"value":"UYT","time-utc":"UTC−03:00","time":"−03:00","label":"UYT (UTC−03:00)"},
{"value":"WGT","time-utc":"UTC−03:00","time":"−03:00","label":"WGT (UTC−03:00)"},
{"value":"NST","time-utc":"UTC−03:30","time":"−03:30","label":"NST (UTC−03:30)"},
{"value":"NT","time-utc":"UTC−03:30","time":"−03:30","label":"NT (UTC−03:30)"},
{"value":"AST-4","time-utc":"UTC−04:00","time":"−04:00","label":"AST(Atlantic) (UTC−04:00)"},
{"value":"ECT-4","time-utc":"UTC−04:00","time":"−04:00","label":"ECT(Eastern Caribbean) (UTC−04:00)"},
{"value":"AMT-04","time-utc":"UTC−04:00","time":"−04:00","label":"AMT(Amazon) (UTC−04:00)"},
{"value":"BOT","time-utc":"UTC−04:00","time":"−04:00","label":"BOT (UTC−04:00)"},
{"value":"CLT","time-utc":"UTC−04:00","time":"−04:00","label":"CLT (UTC−04:00)"},
{"value":"COST","time-utc":"UTC−04:00","time":"−04:00","label":"COST (UTC−04:00)"},
{"value":"EDT","time-utc":"UTC−04:00","time":"−04:00","label":"EDT (UTC−04:00)"},
{"value":"FKT","time-utc":"UTC−04:00","time":"−04:00","label":"FKT (UTC−04:00)"},
{"value":"GYT","time-utc":"UTC−04:00","time":"−04:00","label":"GYT (UTC−04:00)"},
{"value":"PYT","time-utc":"UTC−04:00","time":"−04:00","label":"PYT (UTC−04:00)"},
{"value":"VET","time-utc":"UTC−04:00","time":"−04:00","label":"VET (UTC−04:00)"},
{"value":"ACT-5","time-utc":"UTC−05:00","time":"−05:00","label":"ACT(Acre) (UTC−05:00)"},
{"value":"ECT-5","time-utc":"UTC−05:00","time":"−05:00","label":"ECT(Ecuador)  (UTC−05:00)"},
{"value":"CDT","time-utc":"UTC−05:00","time":"−05:00","label":"CDT (UTC−05:00)"},
{"value":"COT","time-utc":"UTC−05:00","time":"−05:00","label":"COT (UTC−05:00)"},
{"value":"EASST","time-utc":"UTC−05:00","time":"−05:00","label":"EASST (UTC−05:00)"},
{"value":"PET","time-utc":"UTC−05:00","time":"−05:00","label":"PET (UTC−05:00)"},
{"value":"CST-6","time-utc":"UTC−06:00","time":"−06:00","label":"CST(North America) (UTC−06:00)"},
{"value":"EAST","time-utc":"UTC−06:00","time":"−06:00","label":"EAST (UTC−06:00)"},
{"value":"GALT","time-utc":"UTC−06:00","time":"−06:00","label":"GALT (UTC−06:00)"},
{"value":"MDT","time-utc":"UTC−06:00","time":"−06:00","label":"MDT (UTC−06:00)"},
{"value":"MST-7","time-utc":"UTC−07:00","time":"−07:00","label":"MST(North America) (UTC−07:00)"},
{"value":"PDT","time-utc":"UTC−07:00","time":"−07:00","label":"PDT (UTC−07:00)"},
{"value":"AKDT","time-utc":"UTC−08:00","time":"−08:00","label":"AKDT (UTC−08:00)"},
{"value":"CIST","time-utc":"UTC−08:00","time":"−08:00","label":"CIST (UTC−08:00)"},
{"value":"AKST","time-utc":"UTC−09:00","time":"−09:00","label":"AKST (UTC−09:00)"},
{"value":"GAMT","time-utc":"UTC−09:00","time":"−09:00","label":"GAMT (UTC−09:00)"},
{"value":"GIT","time-utc":"UTC−09:00","time":"−09:00","label":"GIT (UTC−09:00)"},
{"value":"HDT","time-utc":"UTC−09:00","time":"−09:00","label":"HDT (UTC−09:00)"},
{"value":"MART","time-utc":"UTC−09:30","time":"−09:30","label":"MART (UTC−09:30)"},
{"value":"MIT","time-utc":"UTC−09:30","time":"−09:30","label":"MIT (UTC−09:30)"},
{"value":"CKT","time-utc":"UTC−10:00","time":"−10:00","label":"CKT (UTC−10:00)"},
{"value":"HST","time-utc":"UTC−10:00","time":"−10:00","label":"HST (UTC−10:00)"},
{"value":"SDT","time-utc":"UTC−10:00","time":"−10:00","label":"SDT (UTC−10:00)"},
{"value":"TAHT","time-utc":"UTC−10:00","time":"−10:00","label":"TAHT (UTC−10:00)"},
{"value":"SST-11","time-utc":"UTC−11:00","time":"−11:00","label":"SST(Samoa) (UTC−11:00)"},
{"value":"NUT","time-utc":"UTC−11:00","time":"−11:00","label":"NUT (UTC−11:00)"},
{"value":"BIT","time-utc":"UTC−12:00","time":"−12:00","label":"BIT (UTC−12:00)"},
{"value":"IDLW","time-utc":"UTC−12:00","time":"−12:00","label":"IDLW (UTC−12:00)"}]
const hour  = [
    {label : '00:00',value : '00:00:00'},
    {label : '01:00',value : '01:00:00'},
    {label : '02:00',value : '02:00:00'},
    {label : '03:00',value : '03:00:00'},
    {label : '04:00',value : '04:00:00'},
    {label : '05:00',value : '05:00:00'},
    {label : '06:00',value : '06:00:00'},
    {label : '07:00',value : '07:00:00'},
    {label : '08:00',value : '08:00:00'},
    {label : '09:00',value : '09:00:00'},
    {label : '10:00',value : '10:00:00'},
    {label : '11:00',value : '11:00:00'},
    {label : '12:00',value : '12:00:00'},
    {label : '13:00',value : '13:00:00'},
    {label : '14:00',value : '14:00:00'},
    {label : '15:00',value : '15:00:00'},
    {label : '16:00',value : '16:00:00'},
    {label : '17:00',value : '17:00:00'},
    {label : '18:00',value : '18:00:00'},
    {label : '19:00',value : '19:00:00'},
    {label : '20:00',value : '20:00:00'},
    {label : '21:00',value : '21:00:00'},
    {label : '22:00',value : '22:00:00'},
    {label : '23:00',value : '23:00:00'},
    
    
]
export const roles =  [
    { "value": "composer", "label_ko": "작곡가", "label_en": "Composer" },
    { "value": "lyricist", "label_ko": "작사가", "label_en": "Lyricist" },
    { "value": "arranger", "label_ko": "편곡가", "label_en": "Arranger" },
    { "value": "producer", "label_ko": "프로듀서", "label_en": "Producer" },
    { "value": "co_producer", "label_ko": "공동 프로듀서", "label_en": "Co-Producer" },
    { "value": "publisher", "label_ko": "퍼블리셔", "label_en": "Publisher" },

    { "value": "assistant_engineer", "label_ko": "어시스턴트 엔지니어", "label_en": "Assistant Engineer" },
    { "value": "recording_engineer", "label_ko": "레코딩 엔지니어", "label_en": "Recording Engineer" },
    { "value": "mixing_engineer", "label_ko": "믹싱 엔지니어", "label_en": "Mixing Engineer" },
    { "value": "immersive_mixing_engineer", "label_ko": "이머시브 믹싱 엔지니어", "label_en": "Immersive Mixing Engineer" },
    { "value": "mastering_engineer", "label_ko": "마스터링 엔지니어", "label_en": "Mastering Engineer" },
    { "value": "editing_engineer", "label_ko": "편집 엔지니어", "label_en": "Editing Engineer" },

    { "value": "conductor", "label_ko": "지휘자", "label_en": "Conductor" },
    { "value": "translator", "label_ko": "번역가", "label_en": "Translator" },
    { "value": "narrator", "label_ko": "내레이터", "label_en": "Narrator" },
    { "value": "studio_musician", "label_ko": "세션 뮤지션", "label_en": "Studio Musician" },
]

export const instruments = [
    { "value": "vocals", "label_ko": "보컬", "label_en": "Vocals" },
    { "value": "guitar", "label_ko": "기타", "label_en": "Guitar" },
    { "value": "bass_guitar", "label_ko": "베이스 기타", "label_en": "Bass Guitar" },
    { "value": "drums", "label_ko": "드럼", "label_en": "Drums" },
    { "value": "piano", "label_ko": "피아노", "label_en": "Piano" },
    { "value": "keyboards", "label_ko": "키보드", "label_en": "Keyboards" },
    { "value": "synthesizer", "label_ko": "신디사이저", "label_en": "Synthesizer" },
    { "value": "percussion", "label_ko": "퍼커션", "label_en": "Percussion" },
    { "value": "background_vocals", "label_ko": "백그라운드 보컬", "label_en": "Background Vocals" },
    { "value": "programming", "label_ko": "프로그래밍", "label_en": "Programming" },

    { "value": "violin", "label_ko": "바이올린", "label_en": "Violin" },
    { "value": "cello", "label_ko": "첼로", "label_en": "Cello" },
    { "value": "viola", "label_ko": "비올라", "label_en": "Viola" },
    { "value": "viola_de_gamba", "label_ko": "비올라 다 감바", "label_en": "Viola de Gamba" },
    { "value": "flute", "label_ko": "플루트", "label_en": "Flute" },
    { "value": "trumpet", "label_ko": "트럼펫", "label_en": "Trumpet" },
    { "value": "saxophone", "label_ko": "색소폰", "label_en": "Saxophone" },
    { "value": "clarinet", "label_ko": "클라리넷", "label_en": "Clarinet" },
    { "value": "trombone", "label_ko": "트롬본", "label_en": "Trombone" },
    { "value": "horn", "label_ko": "호른", "label_en": "Horn" },
    { "value": "organ", "label_ko": "오르간", "label_en": "Organ" },

    { "value": "soprano", "label_ko": "소프라노", "label_en": "Soprano" },
    { "value": "alto", "label_ko": "알토", "label_en": "Alto" },
    { "value": "tenor", "label_ko": "테너", "label_en": "Tenor" },
    { "value": "bass", "label_ko": "베이스", "label_en": "Bass" },

    { "value": "choir", "label_ko": "합창단", "label_en": "Choir" },
    { "value": "orchestra", "label_ko": "오케스트라", "label_en": "Orchestra" },
    { "value": "ensemble", "label_ko": "앙상블", "label_en": "Ensemble" },

    { "value": "harmonica", "label_ko": "하모니카", "label_en": "Harmonica" },
    { "value": "accordion", "label_ko": "아코디언", "label_en": "Accordion" },
    { "value": "harp", "label_ko": "하프", "label_en": "Harp" },
    { "value": "harpsichord", "label_ko": "하프시코드", "label_en": "Harpsichord" },
    { "value": "oboe", "label_ko": "오보에", "label_en": "Oboe" },
    { "value": "lute", "label_ko": "류트", "label_en": "Lute" },
    { "value": "banjo", "label_ko": "밴조", "label_en": "Banjo" },
    { "value": "sampled_artist", "label_ko": "샘플 사용 아티스트", "label_en": "Sampled Artist" },
    { "value": "remixer", "label_ko": "리믹서", "label_en": "Remixer" },
]
const optionData = {
    userState,
    timezone,
    hour,
    withrawalState,
    boolean ,
    contributors,
    copyrightType,
    albumSource,
    releaseType,
    youtubeCID,
    language,
    artistType,
    sns,
    albumStatus,
    trackType,
    userObject,
    payment,
    reference,
    country,
    dialing,
    bank,
    role,
    lang,
    entity,
    memberKeyword,
    artistKeyword,
    currency,
    showNumber,
    adminList,
    roles,
    instruments
}
export default optionData;
